export default {
    loading: "En cours de chargement...",
    clientSelector: {
        title: "Changer de client",
        searchPlaceHolder: "Rechercher un client...",
        noResults: "Aucun client trouvé"
    },
    dataNotFoundError: "La page demandée n'existe pas ou n'a pas pu être chargée.",
    asyncSearchMessage: "Ecrivez 3 caractères ou plus et appuyez sur entrée...",
    terminatedClientModification: "Les clients avec le statut terminé sont en lecture seule.",
    inactiveOrTerminatedClientAssociationError: "Impossible d'associer l'utilisateur à ces clients. Les clients suivants sont inactifs ou terminés : {clients}",
    externalToInternalRoleChangeError: "Impossible de changer le rôle d'un utilisateur externe vers un rôle interne.",
    membersArchivedModification: "Les participants archivés ne peuvent pas être modifiés.",
    clientArchivedModification: "Les informations des clients archivés ne peuvent pas être modifiées.",
    divisionArchivedModification: "Les informations des divisions archivés ne peuvent pas être modifiées.",
    classArchivedModification: "Les informations des classes archivés ne peuvent pas être modifiées.",
    dependentPersonArchivedModification: "Les informations des personnes à charge archivés ne peuvent pas être modifiées.",
    noPreviousCoverageForRole: "Vous n'êtes pas autorisé(e) à créer la première couverture d'un participant. Veuillez contacter votre gestionnaire de compte.",
    asyncSearchWithoutEnter: "Ecrivez 3 caractères ou plus...",
    dtv2ClearFilter: "Vider les filtres",
    characterCount: "{currentCount} caractères restants",
    pleaseResetFilters:
        "Une erreur est survenu lors du traitement de vos filtres sauvegardés, veuillez vider vos filtres en cliquant sur le bouton « Vider les filtres ».",
    invalidDataFollowUp: "Au moins un des suivis sélectionné est fermé et ne peut donc pas être modifié",
    genericSaveError: "Une erreur s'est produite lors de l'enregistrement de vos informations.",
    genericServerError: "Une erreur technique est survenue.",
    genericDataFetchError: "Une erreur inconnue s'est produite lors de la récupération des données. Veuillez réessayer plus tard ou contacter le support.",
    pastLastActiveDateError:
        "Les données associées au client ne peuvent être modifiées ou créées après sa dernière date d'activité",
    retroactiveLimitError:
        "Les données que vous essayez de modifier dépassent la limite rétroactive autorisée. Veuillez contacter le support si vous devez apporter des modifications.",
    fileNameSpecialCharError:
        "Le nom du fichier que vous essayez de téléverser contient des caractères invalides ({invalidChars}), veuillez renommer le fichier.",
    genericSaveSuccess: "Les données ont été sauvegardées avec succès",
    archiveWarning: "ATTENTION : l'archivage est définitif et irréversible",
    allMembersArchivedError: "Tous les participants sélectionnés sont archivés ou introuvables et ne peuvent pas avoir leurs fichiers regénérés.",
    allMembersNonEligibleError: "Tous les participants sélectionnés ont déjà eu une regénération de fichier en succès et ne peuvent pas avoir leurs fichiers générés à nouveau.",
    hint: "Remarque:",
    accountingExport: {
        billingPeriod: "Période de facturation",
        version: "Versions téléchargables",
        acomba: "Acomba (Standard)",
        acombaDelayed: "Acomba (Décalé)",
        acomba_csv: "Acomba CSV (Standard)",
        acomba_csv_delayed: "Acomba CSV (décalé)",
        selectedPeriod: "Période sélectionnée",
        unavailable: "Le rapport que vous essayez de télécharger n'est pas disponible actuellement.",
        warning: "L’historique des périodes de facturation est consultable via la pagination.",
    },
    insurerExport: {
        selectedPeriod: "Période sélectionnée",
    },
    versionToggle: {
        fr: "Version FR",
        en: "Version EN",
    },
    toast: {
        visualization:
            "Votre facture est en cours de visualisation. La génération peut prendre quelques minutes. Ce message disparaîtra lorsque la génération sera terminée.",
        generation:
            "Votre document est en cours de génération. La génération peut prendre quelques minutes. Ce message disparaîtra lorsque la génération sera terminée.",
    },
    importErrors: {
        columnError: "Le nombre de colonnes dans le fichier est incorrect.{br}{br}Nombre de colonnes du fichier : {fileNum}.{br}Nombre de colonnes attendu : {expectedNum}",
        dataTypeError: "Une erreur de type de donnée s'est produite. Veuillez vérifier les données et vous assurez d'avoir la dernière version de structure du fichier disponible.",
        dataTypeErrorWithValue: "Une erreur de type de donnée s'est produite pour la valeur : {value}. Veuillez vérifier les données et vous assurez d'avoir la dernière version de structure du fichier disponible.",
        dataTypeErrorDivision: "Division inconnue : {value}",
        dataTypeErrorClass: "Classe inconnue : {value}",
        dataTypeLengthError: "La valeur suivante dépasse la longueur maximale : {value}. La longueur maximale autorisée pour ce champ est {length}. Veuillez vous assurer que cette valeur, ainsi que toutes les autres saisies pour ce champ, respectent les limites définies.",
        dataTypeErrorCoverage: "Couverture inconnue : {value}",
        startDateError: "La date de début {startDate} est antérieure à la date de début de la période de facturation {billingPeriodStartDate}.",
        endDateError: "La date de fin {endDate} est antérieure à la date de début {startDate}.",
        uniqueNumberError: "Le numéro unique ne peut contenir que des chiffres : {value}.",
        classMissingCoverageError: "La classe du client doit avoir au moins une couverture : {value}.",
        duplicateMemberError: "Numéro de participant en double : {value}.",
        unknownError: "Une erreur inconnue s'est produite : {value}.",
        unauthorizedCountryCode: "Veuillez vérifier les pays / provinces autorisés dans le formulaire client ; la donnée suivante n'est pas acceptée : {country}",
        valueRequiredError: "Importation interrompue : une erreur a été détectée dans le fichier.{br}Première erreur détectée : Une valeur est requise, onglet {sheet}, ligne {row}, colonne #{column} ({columnName}).{br}Veuillez corriger cette erreur et vérifier l'ensemble du fichier avant de relancer l'importation, car d'autres erreurs pourraient être présentes.",
    },
    downloader: {
        acombaExport: "Exportation acomba",
        clientMajorCardExport: "Exportation cartes Major",
        receivable: "Exportation recevables",
        payable: "Exportation payables",
        clientSalaryExport: "Exportation des salaires des membres",
        memberMajorCard: "Exportation carte(s) Major",
        coverageConfirmations: "Exportation des confirmations de couverture du client",
        clientReport: "Exportation rapport client",
        enelReport: "Rapport MSPA",
        maximumAge: "Âge maximal de personne à charge",
        payroll: "Rapport de ventilation (paie)",
        certificateByCoverage: "Rapport de certificat par type de couverture",
        coverageStatus: "Rapport des status de couvertures",
        taxBenefit: "Rapport des bénéfices imposables",
        insurerExport: "Exportation assureur",
        clientAttachment: "Téléchargement fichier client",
        suppliersReports: "Téléchargement rapport fournisseur",
        coverageConfirmation: "Génération de confirmation de couverture",
        invoiceDownload: "Téléchargement de facture",
        eligibilityReport1: "Rapport de certificat 1",
        eligibilityReport2: "Rapport de certificat 2",
        premiumReport: "Prime",
        akiraReport: "Akira",
        clientExport: "Exportation client",
        symbility: "Modèle Symbility",
        mondial: "Modèle Liste voyage",
        provinces: "Provinces",
        divisions: "Divisions",
        weekly: "Hebdomadaire",
        biweekly: "Aux deux semaines",
        semiMonthly: "Bimensuel",
        monthly: "Mensuel",
        yearly: "Annuel",
        duplicateDownload: "Le fichier que vous voulez télécharger est déjà en cours de téléchargement: {br} {file}",
        feus: "FEUS",
        visualizationError: "La facture que vous essayez de télécharger n'est pas complètement visualisée.",
    },
    admin: {
        title: "Admin",
        blocs: {
            title: "Blocs",
            datatable: {
                actions: {
                    add: "Ajouter un bloc",
                    archiveWarning: "ATTENTION : l'archivage est définitif et irréversible. Archiver le bloc retirera tous les clients de celui-ci.",
                    edit: "Modifier un bloc",
                    includeArchivedBlocs: "Inclure les blocs archivés",
                    showConfirm: {
                        title: "Attention !",
                        message:
                            "Si vous fermez maintenant vos données ne seront pas sauvegardées. Souhaitez-vous continuer ?",
                    },
                },
                columns: {
                    name: "Nom",
                    clientCount: "Nombre de clients dans ce bloc",
                },
            },
            form: {
                name: "Nom",
            },
            bloc: {
                pages: {
                    clients: "Clients",
                    settings: "Paramètres",
                },
                clients: {
                    datatable: {
                        actions: {
                            editButton: "Modifier le bloc",
                            editTitle: "Assignation des clients du bloc",
                        },
                    },
                    form: {
                        assigned: "Clients assignés à ce bloc",
                        unassigned: "Clients non-assignés",
                    },
                },
                settings: {
                    form: {
                        titles: {
                            ledger: "Grands Livres",
                            taxes: "Taxes d'Assurances",
                            insurers: "Fournisseurs",
                        },
                        ledgers: {
                            acombaGstNumber: "TPS",
                            acombaQstNumber: "TVQ",
                            acombaHstNumber: "TVH",
                            acombaPremiumNumber: "Prime",
                            acombaFeeNumber: "Frais",
                            acombaReserveNumber: "Réserve",
                            acombaReceivableNumber: "Recevable",
                            acombaPayableNumber: "Payable",
                        },
                    },
                },
            },
        },
        accounts: {
            title: "Comptabilité",
            recievables: {
                title: "Recevables",
                heading: "Comptes recevables du Grand Livre ",
                generalAccount: "Compte général des recevables",
                insuranceTax: "Taxes d'assurance à recevoir",
                salesTax: "Taxes de vente à recevoir",
                gst: "TPS",
                qst: "TVQ",
                hst: "TVH",
                premium: "Primes à recevoir(hors-taxes)",
                commissions: "Avances des commissions",
            },
            payables: {
                title: "Payables",
                heading: "Comptes payables du Grand Livre",
                generalAccount: "Compte général des payables",
                reservedClients: "Réserve des clients",
                insuranceTaxToPay: "Taxes d'assurance à payer",
                salesTaxToPay: "Taxes de vente à payer",
                gst: "TPS",
                qst: "TVQ",
                hst: "TVH",
                majorIncome: "Revenus Major",
                commissions: "Commissions",
                fees: "Frais",
                markup: "Majoration",
                premium: "Primes à payer(hors-taxes)",
                brokerCommissions: "Commissions des courtiers",
                insuranceTaxMarkup: "Taxes d'assurance sur majoration",
                salesTaxMarkup: "Taxes de vente sur majoration",
            },
            businessunits: {
                title: "Unités d'affaires",
                shortTitle: "Unités",
                heading: "Unités d'affaires du Grand Livre",
                GM: "Groupe Major",
                PM: "Plan Major",
            },
        },
        guarantees: {
            title: "Garanties",
            datatable: {
                actions: {
                    add: "Ajouter une garantie",
                    edit: "Modifier la garantie",
                    includeArchivedGuarantees: "Inclure les garanties archivées",
                    showConfirm: {
                        title: "Attention !",
                        message:
                            "Si vous fermez maintenant vos données ne seront pas sauvegardées. Souhaitez-vous continuer ?",
                    },
                },
                columns: {
                    name: "Nom",
                    shortName: "Abréviation",
                    code: "Code additionnel",
                    category: "Catégorie",
                    type: "Type",
                },
            },
            form: {
                name: "Nom",
                shortName: "Abréviation",
                code: "Code additionnel (s'il y a lieu)",
                taxableIncomeFederal: "Bénéfices imposables au fédéral",
                taxableIncomeQuebec: "Bénéfices imposables au provincial (Québec)",
                quebecHealthPremium: "Prime Santé (Québec)",
                provincialTaxableBenefits: "Bénéfices imposables au provincial (Hors-Québec)",
                type: "Type",
                guaranteeCategory: "Catégorie",
                formula: "Volume / [N] * Taux",
                dependsOnGuaranteeId: "Dépend de",
                dependsOnGuaranteeIdTooltip: "Définit si cette garantie dépend d'une autre. Si c'est le cas, son affichage et son comportement par défaut, notamment dans les couvertures de participant, seront impactés. Cette valeur peut être redéfinie au niveau du client. Ce champ est désactivé si la garantie est définie comme pilote de garantie obligatoire de personne à charge ou comme garantie obligatoire de personne à charge.",
                isAutomaticallyChecked: "Activée automatiquement",
                isAutomaticallyCheckedTooltip: "Définit si cette garantie doit automatiquement être activée dans une couverture selon la configuration en vigueur du participant. Pour les garanties de type \"Grille de tarifs\" dépendantes d'une autre, si cette option est cochée et que le type de la garantie parente est défini, elles seront activées et hériteront du même type. Les garanties de type \"Par adhérent\" ou \"Par adhérent (taux facturé)\" ne peuvent pas être activées automatiquement. Cette valeur peut être redéfinie au niveau du client.",
                isMandatoryDependentGuarantee: "Garantie obligatoire de personnes à charge",
                isMandatoryDependentGuaranteeTooltip: "Définit si cette garantie concerne les personnes à charge et est considérée comme obligatoire. Si c'est le cas, son comportement est alors impacté par la présence et le type des garanties la pilotant.",
                isDrivingMandatoryDependentGuarantee: "Garantie pilotant les garanties obligatoires de personnes à charge",
                isDrivingMandatoryDependentGuaranteeTooltip: "Définit si cette garantie pilote celles concernant les personnes à charge et considérées comme obligatoires. Si c'est le cas, sa présence et son type impacte alors ces dernières. Ce champ est réservé aux garanties de type \"Grille de tarifs\". Ce champ est désactivé si la garantie dépend d'une autre.",
                errors: {
                    quebecAndOutOfQuebec: "Veuillez choisir entre Québec et hors-Québec",
                    mandatoryAndDriving: "Une garantie ne peut pas être à la fois une garantie obligatoire de personnes à charge et une garantie pilote",
                    mandatoryAndMaster: "Une garantie obligatoire de personnes à charge ne peut pas être une garantie principale",
                    drivingRequiresPriceList: "Le champ \"Garantie pilotant les garanties obligatoires de personnes à charge\" est réservé aux garanties de type \"Grille de tarifs\"",
                    drivingCannotDependOn: "Il n'est pas possible pour une garantie pilote de garantie obligatoire de personne à charge d'être définie comme garantie dépendante d'une autre",
                    dependsOnCannotBeDriving: "Il n'est pas possible pour une garantie dépendante d'une autre d'être définie comme garantie pilote de garantie obligatoire de personne à charge",
                    autoCheckIncompatibleWithMemberTypes: "Le champ \"Activée automatiquement\" n'est pas compatible avec les types de garantie \"Par adhérent\" et \"Par adhérent (Taux facturé)\"",
                    dependsOnCannotBeMaster: "Il n'est pas possible pour une garantie parente d'être définie comme garantie obligatoire de personne à charge",
                },
            },
            types: {
                fixed: "Fixe",
                list: "Grille de tarifs",
                formula: "Formule",
                member: "Par adhérent",
                memberMultiplier: "Par adhérent (Taux facturé)",
            },
            categoryTypes: {
                experience: "Expérience",
                mutual: "Mutualisée",
                other: "Autre produit",
            },
            modal: {
                clientConfigurationMessageSingular: "Cette garantie ne peut pas être définie comme garantie pilote, car elle dépend d'une autre garantie dans le client suivant :<br/>",
                clientConfigurationMessagePlural: "Cette garantie ne peut pas être définie comme garantie pilote, car elle dépend d'une autre garantie dans les clients suivants :<br/>",
                clientConfigurationMessageMandatoryDependentSingular: "Cette garantie ne peut pas être définie comme garantie obligatoire de personnes à charge car elle dépend d'une autre garantie dans le client suivant :<br/>",
                clientConfigurationMessageMandatoryDependentPlural: "Cette garantie ne peut pas être définie comme garantie obligatoire de personnes à charge car elle dépend d'une autre garantie dans les clients suivant :<br/>",
            },
        },
        taxes: {
            title: "Taxes",
            subTitle: "Numéros de taxes",
            datatable: {
                columns: {
                    taxName: "Nom de taxe",
                    taxNumber: "Numéro de taxe",
                },
                taxTypes: {
                    insurance: "TAXES D'ASSURANCES",
                },
            },
        },
        insurers: {
            title: "Fournisseurs",
            datatable: {
                actions: {
                    add: "Ajouter un fournisseur",
                    edit: "Modifier le fournisseur",
                    includeArchivedInsurers: "Inclure les fournisseurs archivés",
                    showConfirm: {
                        title: "Attention !",
                        message:
                            "Si vous fermez maintenant vos données ne seront pas sauvegardées. Souhaitez-vous continuer ?",
                    },
                },
                columns: {
                    contactFullName: "Contact administratif",
                    emailAddress: "Courriel",
                    insurer: "Fournisseur",
                    phoneNumber: "Téléphone",
                },
            },
            form: {
                generalInformation: {
                    title: "Information générale",
                    name: "Nom",
                    address: "Adresse",
                    city: "Ville",
                    province: "Province",
                    postalCode: "Code Postal",
                    emergencyPhoneNumber: "Téléphone d'urgence",
                    website: "Site web",
                    selfInsured: "Auto-assuré",
                },
                contacts: {
                    title: "Contacts",
                    adminTitle: "Contact administratif",
                    salesTitle: "Contact de vente",
                    fullName: "Nom",
                    phoneNumber: "Téléphone",
                    emailAddress: "Courriel",
                    language: "Langue de contact",
                },
                accounts: {
                    title: "Comptabilité",
                    acombaTitle: "Configuration acomba",
                    providerNumber: "Numéro de fournisseur",
                },
            },
        },
        brokers: {
            broker: "Courtier",
            brokerInformation: "Informations du courtier",
            adminContact: "Contact administratif",
            phoneNumber: "Numéro de téléphone",
            emailAddress: "Adresse courriel",
            actions: "Actions",
            add: "Ajouter",
            addBroker: "Ajouter un courtier",
            modifyBroker: "Modifier le courtier",
            fullName: "Nom complet",
            generalInformation: "Informations du courtier",
            identificationNumber: "Code d'identification",
            acombaNumber: "Numéro de fournisseur Acomba",
            affiliatedFirm: "Cabinet rattaché",
            contactLanguageCode: "Langue de contact",
            type: "type",
            adminEmailAddress: "Adresse courriel",
            adminContactFullName: "Nom complet",
            adminPhoneNumber: "Numéro de téléphone",
            adminContactLanguageCode: "Langue de contact",
            firm: "Cabinet",
            modify: "Modifier",
            includeArchived: "Inclure les courtiers archivés",
            compensationType: "Type de rémunération",
            calculationTypes: "Base de calculs",
            brokerPart: "Part du courtier",
            cashAdvance: "Avance",
            enums: {
                monthly: "mensuel",
                yearly: "annuel",
                oneTime: "unique",
                fixed: "Fixe",
                percentage: "Pourcentage",
            },
            showConfirm: {
                title: "Attention !",
                message: "Si vous fermez maintenant vos données ne seront pas sauvegardées. Souhaitez-vous continuer ?",
            },
        },
        pages: {
            guarantees: "Garanties",
            insurers: "Fournisseurs",
            brokers: "Courtiers",
            users: "Utilisateurs",
            blocs: "Blocs",
            taxes: "Taxes",
            groups: "Regroupements",
        },
        users: {
            title: "Utilisateurs",
            datatable: {
                actions: {
                    addUser: "Ajouter un utilisateur",
                    editUser: "Modifier l'utilisateur",
                    includeArchivedUsers: "Inclure les utilisateurs archivés",
                    viewUser: "Visionner l'utilisateur",
                    showConfirm: {
                        title: "Attention !",
                        message:
                            "Si vous fermez maintenant vos données ne seront pas sauvegardées. Souhaitez-vous continuer ?",
                    },
                },
                columns: {
                    username: "Identifiant",
                    emailAddress: "Adresse courriel",
                    language: "Langue",
                    name: "Nom",
                    role: "Rôle",
                    status: "Statut",
                    menrolStatus: "Statut Menrol",
                },
            },
            form: {
                username: "Identifiant",
                emailAddress: "Courriel",
                firstName: "Prénom",
                language: "Langue d'interface",
                lastName: "Nom",
                password: "Mot de passe",
                role: "Rôle",
                RoleInternal: "Rôles internes",
                RoleExternal: "Rôles externes",
                businessAccount: "Unité d'affaire",
                associatedClientId: "Clients",
                phone: "Téléphone",
                mfa: "Préférence de réception du code MFA",
                resetPassword: "Réinitialiser le mot de passe",
                menrolAccess: "Accorder l'accès à MENROL",
                clientUserCreationNote:
                    "Veuillez vous assurer que le compte utilisateur de l'administrateur de régime que vous souhaitez créer n'existe pas déjà dans l'application en étant associé à un autre client. Si c'est le cas, merci de le modifier afin d'ajouter le client voulu. Le créer ici créera un nouveau compte utilisateur.",
                confirmationTitle: "Attention !",
                passwordResetConfirmation:
                    "Si vous demandez une réinitialisation du mot de passe de l'utilisateur, une notification lui sera envoyée à l'adresse courriel suivante {email}. Souhaitez-vous poursuivre ?",
                successTitle: "Information",
                userCreationSuccess:
                    "L'utilisateur {userName} a été créé avec succès, une notification avec ses informations de connexion lui a été envoyée. Un suivi automatique a été ouvert, il sera fermé suite à la première connexion de l'utilisateur.",
                emailChangedConfirmation:
                    "Si vous modifiez l'adresse courriel de l'utilisateur, une notification lui sera envoyée pour l'informer à l'adresse suivante {email}. Souhaitez-vous poursuivre ?",
            },
            statuses: {
                active: "Actif",
                blocked: "Bloqué",
                waiting: "En Attente",
            },
            menrolStatuses: {
                active: "Actif",
                inactive: "Inactif",
                nonexistent: "Inexistant",
            },
            types: {
                phone: "Par application",
                email: "Par courriel",
                noMFA: "Aucun MFA",
            },
            errors: {
                administratorRoleCreateError: "Vous n'êtes pas autorisé(e) à créer un compte administrateur technique.",
                administratorRoleUpdateError: "Vous n'êtes pas autorisé(e) à mettre à jour le rôle d'un compte vers administrateur technique."
            }
        },
        groups: {
            title: "Regroupements",
            datatable: {
                actions: {
                    add: "Ajouter un regroupement",
                    edit: "Modifier le regroupement",
                    view: "Voir le regroupement",
                    archiveWarning: "ATTENTION : l'archivage est définitif et irréversible. Archiver le regroupement retirera tous les clients de celui-ci.",
                    includeArchivedGroups: "Inclure les regroupements archivés",
                },
                columns: {
                    name: "Nom",
                    createdBy: "Créé par",
                    createdAt: "Créé le",
                },
            },
            form: {
                name: "Nom du regroupement",
            },
        },
    },
    app: {
        title: "Major System",
    },
    attachments: {
        attachmentLabel: "Pièces jointes",
        attachmentListEmpty: "Aucune pièce jointe",
        attachmentDescription: "Glissez le fichier à téléverser ici",
        attachmentWarning: "Le nom du fichier ne peut excéder {length} caractères.",
    },
    archiveButton: {
        modal: {
            title: {
                archive: "Archivage!",
                delete: "Suppression!",
                unarchive: "Désarchivage!",
            },
        },
        confirmationMessage: {
            archive: "Êtes-vous certain de vouloir archiver {archivedName}?",
            delete: "Êtes-vous certain de vouloir supprimer {archivedName}?",
            unarchive: "Êtes-vous certain de vouloir désarchiver {archivedName}?",
        },
        warningMessage: {
            guarantees:
                "ATTENTION : l'archivage est définitif et irréversible. Si un client possède un prix de couverture avec cette garantie, cela pourrait créer d'importants problèmes dans le système de facturation et dans les couvertures des participants.",
            insurers:
                "ATTENTION : l'archivage est définitif et irréversible. Si un client possède un prix de couverture avec ce fournisseur, cela pourrait créer d'importants problèmes dans le système de facturation et dans les couvertures des participants.",
            clientCoverages:
                "Attention ! Si une classe du client possède ce prix de couverture, cela pourrait créer d'importants problèmes dans le système de facturation et dans les couvertures des participants.",
            clientClasses:
                "Attention ! Si un participant possède une couverture avec cette classe, cela pourrait créer d'importants problèmes dans le système de facturation et dans les couvertures des participants.",
            clientsAssociated: "Attention ! Cet utilisateur est lié au(x) client(s) ci-dessous.",
        },
    },
    audit: {
        title: "Audit interne",
        datatable: {
            columns: {
                date: "Date",
                user: "Utilisateur",
                action: "Action",
                page: "Détails",
            },
        },
        actions: {
            read: "Afficher",
            create: "Créer",
            update: "Modifier",
            remove: "Supprimer",
            cancel: "Annuler",
            generate: "Générer",
            generateFail: "Faute de génération",
            login: "Connexion",
            exportedToAcomba: "Exporter dans Acomba",
            showConfirm: {
                title: "Attention !",
                message: "Si vous fermez maintenant vos données ne seront pas sauvegardées. Souhaitez-vous continuer ?",
            },
        },
        filters: {
            user: "Utilisateur",
            startDate: "Date de début",
            endDate: "Date de fin",
            allUsers: "Tous les utilisateurs",
        },
        pageName: {
            beneficiary: "Bénéficiaires",
            billingPeriod: "Période de facturation",
            bloc: "Blocs",
            broker: "Courtier",
            changePassword: "Changement de mot de passe",
            class: "Classe",
            client: "Client",
            clientAttachment: "Dépôt de fichiers",
            clientCoverage: "Prix de couverture",
            clientExport: "Exportation de liste",
            clientImport: "Importation de liste",
            clientSalaryExport: "Exportation de liste de salaires",
            clientSalaryImport: "Importation de liste de salaires",
            configurations: "Configurations",
            accountRecievables: "Comptes à recevoir",
            accountPayables: "Comptes fournisseurs",
            accountBusinessUnits: "unités d'affaires",
            connection: "Connexion",
            dependentPerson: "Personnes à charge",
            dependentPersonCoverage: "Couverture pour personnes à charge",
            division: "Division",
            guarantee: "Garantie",
            insurer: "Fournisseur",
            invoice: "Facture",
            invoiceExport: "Export de factures",
            invoiceExportMany: "Export de plusieurs factures",
            member: "Participant",
            memberCoverage: "Couverture du participant",
            processSync: "Synchronisation des participants",
            user: "Utilisateur",
            taxes: "Gestion des taxes",
            confirmCoverage: "Confirmation de couverture",
            insurerExport: "Export fournisseur",
            coveragePeriod: "Periode de couverture",
            clientHistories: "Historique du client",
            generateMajorCard: "Génération d'une carte Major",
            generateMajorCardSending: "Demande de génération et d'envoi de carte Major",
            memberCreation: "Création d'un participant"
        },
    },
    billing: {
        title: "Facturation",
    },
    billingPeriods: {
        title: "Périodes de facturation",
        datatable: {
            actions: {
                add: "Ajouter une période de facturation",
                edit: "Modifier la période de facturation",
                view: "Visionner la période de facturation",
                addConfirmationTitle: "Veuillez confirmer vos entrées",
                addConfirmationMessage:
                    "<p>Les périodes de facturation ne peuvent pas être modifiées ou archivées, veuillez confirmer l'information suivante avant de continuer.</p>" +
                    "<p><strong>Nom : </strong> {name}</p>" +
                    "<p><strong>Date de début : </strong> {startDate}</p>" +
                    "<p><strong>Date de fin : </strong> {endDate}</p>" +
                    "{billingPeriodType, select, RECURRING {} other {" +
                    "{isBillable, select, false {} other {" +
                    "<p><strong>Fréquence des factures d'ajustement (en mois): </strong> {creditsInvoiceFrequency}</p>" +
                    "<p><strong>Nombre de factures d'ajustement: </strong> {creditsInvoiceCount}</p>" +
                    "}}" +
                    "}}" +
                    "<p><strong>Période de désistement : </strong> {withdrawalPeriod, select, NONE {Aucune} other {{withdrawalPeriod}}}</p>" +
                    "{withdrawalPeriod, select, NONE {} other {" +
                    "<p><strong>Conserver les couvertures de la période : </strong> {preserveCoverages, select, NONE {Aucune} other {{preserveCoverages}}}</p>" +
                    "}}" +
                    "<p><strong>Décaler la génération de facture: </strong> {isDelayed, select, true {Oui} false {Non}}</p>",
            },
            columns: {
                name: "Nom",
                creation: "Création",
                startDate: "Date de début",
                endDate: "Date de fin",
                withdrawalPeriod: "Période de désistement",
                withdrawalPeriodStatus: {
                    closed: "Fermée",
                    notAvailable: "N/D",
                    open: "Ouverte",
                },
            },
        },
        form: {
            makeRecurring: "Périodes de facturation récurrente (mensuelles)",
            name: "Nom",
            startMonth: "Mois de départ",
            startDate: "Date de début",
            endDate: "Date de fin",
            hasWithdrawalPeriod: "Période de désistement",
            startWithdrawalDate: "Début de la période de désistement",
            endWithdrawalDate: "Fin de la période de désistement",
            preservePreviousCoverages: "Conserver les couvertures d'une période précédente",
            billingPeriodToPreserve: "Période à conserver",
            isDelayed: "Décaler la génération de facture",
            creditsInvoiceFrequency: "Fréquence des factures d'ajustement (en mois)",
            creditsInvoiceCount: "Nombre de factures d'ajustement",
            description:
                "Cette page vous permet de paramétrer la génération des factures d'ajustement, par défaut ces valeurs sont celles de la configuration du client.\
            Le délai légal pour prendre en compte les ajustements sur une période de facturation est de {year} ans. Vous devez renseigner la fréquence mensuelle de génération des factures d'ajustement sur ces {year} années.",
            calculatedInformation:
                "Une facture d'ajustement sera générée tous les {frequency} mois.<br /> {invoiceCount} factures d'ajustement seront générées sur {year} ans.",
            warnings: {
                isDelayed:
                    "Une fois que l'option de décalage de facturation est cochée et confirmée, vous ne pourrez plus modifier cette option pour la période de facturation.",
                withdrawalOrOtherWithdrawal:
                    "Le client peut choisir un désistement par session ou un désistement annuel et/ou permanent",
                hasSessionWithdrawal:
                    "Le client a opté pour le désistement par session et ne peut donc pas lier deux périodes de facturation",
                relatedBillingPeriod:
                    "Impossible d'activer le désistement par session : le client dispose d'une période de facturation liée ayant une période de désistement dans le futur.",
            },
            error: {
                startDateAfterLastActiveDate:
                    "La date de début de la période de facturation doit être avant le dernier jour d'activité du client.",
                endDateAfterLastActiveDate:
                    "La date de fin de la période de facturation doit être au maximum le dernier jour d'activité du client.",
                startDateAfterCurrentDate:
                    "La date de début de la période de facturation ne peut pas être dans le passé.",
            },
        },

        types: {
            manual: "Manuelle (Modèle Association étudiante)",
            recurring: "Récurrente mensuelle (Modèle Corporatif)",
        },
    },
    bulkSalaries: {
        exportSalaries: {
            title: "Étape 1: Exportation des salaires actuels",
            form: {
                button: "Exporter les salaires des membres",
                exporting: "Exportation en cours",
            },
        },
        importSalaries: {
            title: "Étape 2: Importation des nouveaux salaires",
            confirmation: {
                title: "Confirmation",
                message: "Veuillez confirmer l'information d'importation suivante :",
                fileName: "Nom du fichier",
            },
            form: {
                button: "Importer",
                effectiveDate: "Date d'entrée en vigueur",
                file: "Fichier",
                fileDesc: "Glissez le fichier à téléverser ici",
                importing: "Importation en cours",
            },
            messages: {
                error: "Une erreur s'est produite lors de l'importation des salaires :",
                success: {
                    generic: "L'importation des salaires a été complétée avec succès.",
                    errors: " en erreur.",
                    modified: " {number, plural, one {modifié} other {modifiés}}.",
                    skipped: " {number, plural, one {ignoré} other {ignorés}}.",
                    linkText: "{number} {number, plural, one {participant} other {participants}}",
                    modal: {
                        errors: {
                            title: "Participants avec erreur d'importation",
                        },
                        modified: {
                            title: "Participants modifiés",
                        },
                        skipped: {
                            title: "Participants ignorés",
                        },
                    },
                },
            },
        },
    },
    clientAttachments: {
        modal: {
            fileDepositWarning:
                "Vous disposez de 5 minutes pour faire le dépôt de fichier. En cas d’erreur, merci de recommencer votre action.",
        },
        datatable: {
            actions: {
                add: "Ajout de fichiers",
            },
            columns: {
                createdAt: "Date",
                createdBy: "Ajouté par",
                attachmentName: "Nom du fichier",
            },
        },
    },
    clientClasses: {
        title: "Classes",
        errors: {
            classActiveCoverageError: "Vous ne pouvez pas archiver une classe associée à des couvertures de participants",
            newClassInactivationError:
                "Vous ne pouvez pas créer une classe dont la date de début est après la date d'inactivation du client.",
            modifyClassInactivationError:
                "Vous ne pouvez pas modifier une classe dont la date de début est après la date d'inactivation du client.",
        },
        datatable: {
            actions: {
                add: "Ajouter une classe",
                edit: "Modifier la classe",
                view: "Visionner la classe",
                includeArchivedClasses: "Inclure les classes archivées",
                editConfirmationTitle: "Attention !",
                editConfirmationMessage:
                    "<p>Si applicable: Le retrait d'une garantie pour une classe existante affectera l'ensemble des participants adhérant à celle-ci. Leur couverture sera modifiée le premier du prochain mois, et la prochaine facture reflétera les changements.</p>" +
                    "<p>Si applicable: Pour toute nouvelle garantie ajoutée à une classe existante, il est nécessaire de mettre à jour manuellement la couverture des participants qui souhaitent y adhérer.</p>" +
                    "<p>Êtes-vous certain de vouloir effectuer un changement à cette classe existante?</p>",
                warnings: {
                    noCoverages:
                        "Le client sélectionné ne possède aucun prix de couverture. Veuillez d'abord créer et configurer les prix de couvertures du client avant de créer une classe.",
                },
                showConfirm: {
                    title: "Attention !",
                    message:
                        "Si vous fermez maintenant vos données ne seront pas sauvegardées. Souhaitez-vous continuer ?",
                },
            },
            columns: {
                class: "Classe",
                division: "Division parente",
                status: "Statut",
                externalClassNumber: "Numéro de classe Telus ou Desjardins",
                sync: "Sync",
            },
            toolTips: {
                syncToolTipWarning: "La classe n'est pas synchronisée.",
                syncToolTipWarningWithError: "Une ou plusieurs erreurs de synchronisation se sont produites : {error}",
                syncToolTip: "La classe est synchronisée.",
                syncToolTipArchived: "Les classes archivées ne sont pas synchronisables.",
                syncToolTipStarted: "La synchronisation de la classe est en cours."
            },
            syncDisplayStatus: {
                success: "Toutes les classes sont synchronisées",
                warning: "Certaines classes ne sont pas synchronisées",
                danger: "Aucune classe n’est synchronisée",
            }
        },
        form: {
            name: "Nom de la classe",
            classNumber: "Numéro de la classe",
            externalClassNumber: "Numéro de classe Telus ou Desjardins",
            divisionId: "Numéro de division parent",
            fiscalSplit: {
                startDate: "Applicable à partir de",
                actives: "Garanties actives",
                guarantees: "Garanties",
                inOptimization: "Inclus dans l'optimisation fiscale",
                inactives: "Garanties inactives",
                outOfOptimization: "Hors d'optimisation fiscale",
                employerPortion: "Part employeur",
                exclude: "Exclure",
                type: "Type de part employeur",
                types: {
                    fixed: "Fixe",
                    percentage: "Pourcentage",
                },
            },
            warnings: {
                doubledGuarantee: "Une même garantie ne peut être appliquée plus d'une fois.",
                startDate:
                    "Les modifications apportées à cette classe seront appliquées à partir de la date de début de la période de facturation entrée ci-dessus. Vous ne pouvez pas effectuer de modification au delà de 6 périodes de facturation.",
                startDateGeneric:
                    "Les modifications apportées à cette classe seront appliquées à partir de la date de début de la période de facturation entrée ci-dessus.",
                startDateForRecurring:
                    "Les modifications apportées à cette classe seront appliquées à partir de la date de début de la période de facturation entrée ci-dessus. Les classes ne peuvent être créées ou modifiées qu'à partir de {date} .",
                mandatoryDivision:
                    "Le client doit avoir au moins une division non archivée pour pouvoir créer une classe.",
            },
            syncDisplayStatus: {
                success: "La classe est synchronisée.",
                started: "La synchronisation de la classe est en cours.",
                dangerErrors: "Une ou plusieurs erreurs de synchronisation se sont produites :",
                danger: "La classe n'est pas synchronisée.",
            }
        },
    },
    clientCoverages: {
        title: "Prix des couvertures",
        errors: {
            newClientCoverageInactivationError:
                "Vous ne pouvez pas créer une couverture dont la date de début est après la date d'inactivation du client.",
            modifyClientCoverageInactivationError:
                "Vous ne pouvez pas modifier une couverture dont la date de début est après la date d'inactivation du client.",
        },
        datatable: {
            actions: {
                add: "Ajouter une couverture",
                edit: "Modifier la couverture",
                view: "Visualiser la couverture",
                includeArchivedClientCoverages: "Inclure les couvertures archivées",
                confirmationMessages: {
                    title: "Attention !",
                    editWarning:
                        "<p>La modification de données pour un prix de couverture existant affectera l'ensemble des participants adhérant à la garantie y étant associée. Leur couverture sera modifiée le premier du prochain mois, et la prochaine facture reflétera les changements.</p>" +
                        "<p>Êtes-vous certain de vouloir effectuer un changement?</p>",
                    genericReview:
                        "<p>Veuillez réviser l'information suivante : </p>" +
                        "<p><strong>Applicable à partire du </strong> <span>{startDate}</span></p>" +
                        "<p><strong>Garantie </strong> <span>{guaranteeName}</span></p>" +
                        "<p><strong>Assureur </strong> <span>{insurerName}</span></p>" +
                        "<p><strong>Taux de commission </strong> <span>{commissionRate}&nbsp;%</span></p>" +
                        "<br />",
                    FIXED:
                        "<p><strong>Taux client facturé</strong> <span>{invoicedClientRate} $</span></p>" +
                        "<p><strong>Taux client</strong> <span>{clientRate} $</span></p>" +
                        "<p><strong>Taux fournisseur</strong> <span>{providerRate} $</span></p>",
                    FORMULA_FIXED:
                        "<p><strong>Formule</strong> <span>Volume / {formulaDenominator} * Taux</span></p>" +
                        "<p><strong>Calcul du Volume</strong> <span>Montant fixe</span></p>" +
                        "<p><strong>Volume</strong> <span>{formulaVolume} $</span></p>" +
                        "<p><strong>Taux client facturé</strong> <span>{invoicedClientRate} $</span></p>" +
                        "<p><strong>Taux client</strong> <span>{clientRate} $</span></p>" +
                        "<p><strong>Taux Fournisseur</strong> <span>{providerRate} $</span></p>",
                    FORMULA_SALARY:
                        "<p><strong>Formule</strong> <span>Volume / {formulaDenominator} * Taux</span></p>" +
                        "<p><strong>Calcule du Volume</strong> <span>Calculé selon le salaire annuel</span></p>" +
                        "<p><strong>Salaire annuel</strong> <span>/ {formulaSalaryDenominator, select, 1 {1 An} 12 {12 Mois} 52 {52 Semaines}}</span></p>" +
                        "<br />" +
                        "<p><strong>Portion 1</strong> <span>{formulaPart1, select, null {Totalité} other {{formulaPart1}}} * {formulaMultiple1, select, null {0} other {{formulaMultiple1}}}</span></p>" +
                        "{formulaPart1, select, null {} other {" +
                        "<p><strong>Portion 2</strong> <span>{formulaPart2, select, null {Excédent} other {{formulaPart2}}} * {formulaMultiple2, select, null {0} other {{formulaMultiple2}}}</span></p>" +
                        "{formulaPart2, select, null {} other {" +
                        "<p><strong>Portion 3</strong> <span>{formulaPart3, select, null {Excédent} other {{formulaPart3}}} * {formulaMultiple3, select, null {0} other {{formulaMultiple3}}}</span></p>" +
                        "}}" +
                        "}}" +
                        "<br />" +
                        "<p><strong>Plafonner au</strong> <span>{formulaRoundedNumber} $</span></p>" +
                        "<p><strong>MSPA</strong> <span>{formulaMspa} $</span></p>" +
                        "<p><strong>Maximum</strong> <span>{formulaMaximum} $</span></p>" +
                        "<p><strong>Taux client facturé</strong> <span>{invoicedClientRate} $</span></p>" +
                        "<p><strong>Taux client</strong> <span>{clientRate} $</span></p>" +
                        "<p><strong>Taux Fournisseur</strong> <span>{providerRate} $</span></p>",
                    MEMBER: "<p>La garantie sélectionnée est de type 'Par adhérent'.</p>",
                    MEMBER_MULTIPLIER: "<p>La garantie sélectionnée est de type 'Par adhérent (Taux facturé)'.</p>",
                    PRICE_LIST_DEFAULTS:
                        "<p class='headers'><strong>Classe</strong><strong>Couverture</strong><strong>Taux client facturé</strong><strong>Taux client</strong><strong>Taux fournisseur</strong><strong>Frais TPA</strong><strong>Écart</strong></p>" +
                        "<p><span>Défaut</span><span>Individuel</span><span>{defaultInvoicedClientRateSingle} $</span><span>{defaultClientRateSingle} $</span><span>{defaultProviderRateSingle} $</span><span>{defaultTpaFeeSingle} $</span><span>{defaultGapFeeSingle} $</span></p>" +
                        "<p><span>Défaut</span><span>Couple</span><span>{defaultInvoicedClientRateCouple} $</span><span>{defaultClientRateCouple} $</span><span>{defaultProviderRateCouple} $</span><span>{defaultTpaFeeCouple} $</span><span>{defaultGapFeeCouple} $</span></p>" +
                        "<p><span>Défaut</span><span>Famille</span><span>{defaultInvoicedClientRateFamily} $</span><span>{defaultClientRateFamily} $</span><span>{defaultProviderRateFamily} $</span><span>{defaultTpaFeeFamily} $</span><span>{defaultGapFeeFamily} $</span></p>" +
                        "<p><span>Défaut</span><span>Monoparental</span><span>{defaultInvoicedClientRateSingleParent} $</span><span>{defaultClientRateSingleParent} $</span><span>{defaultProviderRateSingleParent} $</span><span>{defaultTpaFeeSingleParent} $</span><span>{defaultGapFeeSingleParent} $</span></p>" +
                        "<p><span>Défaut</span><span>Renoncé</span><span>{defaultInvoicedClientRateWaived} $</span><span>{defaultClientRateWaived} $</span><span>{defaultProviderRateWaived} $</span><span>{defaultTpaFeeWaived} $</span><span>{defaultGapFeeWaived} $</span></p>",
                    PRICE_LIST_LINES:
                        "<p class='{coverageType, select, SINGLE {border-top} other {}}'>" +
                        "<span>{className}</span>" +
                        "<span>{coverageType, select, SINGLE {Individuel} COUPLE {Couple} FAMILY {Famille} SINGLE_PARENT {Monoparental} WAIVED {Renoncé}}</span>" +
                        "<span>{invoicedClientRate} $</span>" +
                        "<span>{clientRate} $</span>" +
                        "<span>{providerRate} $</span>" +
                        "<span>{tpaFee} $</span>" +
                        "<span>{gapFee} $</span>" +
                        "</p>",
                },
            },
            columns: {
                name: "Garantie",
                startDate: "Applicable dès",
                shortName: "Abréviation",
                code: "Code Assomption-Vie",
                type: "Type",
                ageOfPolicyExpiration: "Âge limite",
                ageOfPolicyDecrease: "Âge de diminution",
                applicableTaxes: "Taxes applicables",
                commissionRate: "Taux de commission",
                insurerName: "Fournisseur",
            },
        },
        form: {
            surplusAllocation: "Allocation des surplus",
            commissionRate: "Taux de commission",
            markUpRate: "Majoration",
            clientReserveRate: "Réserve client",
            startDate: "Applicable à partir de",
            description: "Descripteur",
            guaranteeName: "Garantie",
            insurerName: "Fournisseur",
            administrator: "Administrateur de régime",
            policyNumber: "Numero de police",
            ageOfPolicyExpiration: "Âge limite",
            ageOfPolicyDecrease: "Âge de diminution",
            percentageOfPolicyDecrease: "Pourcentage de diminution",
            applicableTaxes: "Taxes applicables (Taux Client)",
            applicableTpaTaxes: "Taxes applicables (Frais TPA)",
            suitableForInternationalMembers: "Applicable aux participants internationaux",
            fixedRate: "Taux fixe",
            fixedType: "Type fixe",
            priceListRate: "Grille de tarifs",
            formulaRate: "Taux par formule",
            memberRate: "Taux par adhésion",
            formula: "Formule",
            formulaVolume: "Volume",
            volumeCalculation: "Calcul du volume",
            rate: "Taux",
            fixed: "Montant fixe",
            perAnnualSalary: "Calculé selon le salaire annuel",
            invoicedClientRate: {
                MONTH: "Taux client facturé mensuel",
                BILLING_PERIOD: "Taux client facturé",
            },
            clientRate: {
                MONTH: "Taux client mensuel",
                BILLING_PERIOD: "Taux client",
            },
            providerRate: {
                MONTH: "Taux fournisseur mensuel",
                BILLING_PERIOD: "Taux fournisseur",
            },
            formulaSalaryDenominator: "Salaire annuel / ",
            formulaPart: "Portion",
            formulaPart1: "Vide = totalité",
            formulaPart2: "Vide = excédent",
            formulaPart3: "Vide = excédent",
            formulaMultiple: "Multiple",
            formulaRoundedNumber: "Plafonner au ",
            formulaMspa: "MSPA",
            formulaMaximum: "Maximum",
            class: "Classe",
            coverage: "Couverture",
            default: "Défaut",
            couple: "Couple",
            family: "Famille",
            single: "Individuel",
            singleParent: "Monoparental",
            waived: "Renoncé",
            memberCoverageMessage: "Le prix de couverture sera configuré dans le formulaire du participant.",
            tpaFee: {
                MONTH: "Frais TPA mensuel",
                BILLING_PERIOD: "Frais TPA",
            },
            gapFee: "Écart",
            warnings: {
                startDate:
                    "Les modifications apportées à ce prix de couverture seront appliquées à partir du début de la période de facturation entrée ci-dessus. Vous ne pouvez pas appliquer de modification au delà des 6 dernières périodes de facturation.",
                startDateGeneric:
                    "Les modifications apportées à ce prix de couverture seront appliquées à partir du début de la période de facturation entrée ci-dessus.",
                startDateForRecurring:
                    "Les modifications apportées à ce prix de couverture seront appliquées à partir du début de la période de facturation entrée ci-dessus. Les couvertures ne peuvent être créées ou modifiées qu'à partir de {date} .",
                billingPeriodRate: "Les taux pour ce client sont configurés par période de facturation.",
            },
        },
        taxTypes: {
            insurance: "Taxe d'assurance",
            none: "Aucune",
            sales: "Taxes de vente",
        },
    },
    clientGuarantees: {
        title: "Configuration de garanties",
        datatable: {
            actions: {
                edit: "Modifier la configuration de garantie",
            },
            columns: {
                guarantee: "Garantie",
                dependsOn: "Dépend de",
                isAutomaticallyChecked: "Activée automatiquement",
            },
        },
        form: {
            guarantee: "Garantie",
            dependsOnGuaranteeId: "Dépend de",
            dependsOnGuaranteeIdTooltip: "Définit si cette garantie dépend d'une autre. Si c'est le cas, son affichage et son comportement par défaut, notamment dans les couvertures de participant, seront impactés. Ce champ est désactivé si la garantie est définie comme pilote de garantie obligatoire de personne à charge ou comme garantie obligatoire de personne à charge.",
            isAutomaticallyChecked: "Activée automatiquement",
            isAutomaticallyCheckedTooltip: "Définit si cette garantie doit automatiquement être activée dans une couverture selon la configuration en vigueur du participant. Pour les garanties de type \"Grille de tarifs\" dépendantes d'une autre, si cette option est cochée et que le type de la garantie parente est défini, elles seront activées et hériteront du même type. Les garanties de type \"Par adhérent\" ou \"Par adhérent (taux facturé)\" ne peuvent pas être activées automatiquement.",
        },
    },
    synchronizations: {
        datatable: {
            title: "Synchronisations",
            columns: {
                status: "Statut",
                date: "Date",
                client: "Client",
                user: "Utilisateur",
                member: "Participant",
                details: "Détails",
                dependents: "Personnes à charges",
                clients: "Clients",
                event: "Événement",
                elementType: "Type d'élément",
                element: "Élément",
                info: "Info",
            },
            elementType: {
                client: "Client",
                division: "Division",
                class: "Classe",
                member: "Participant",
                dependentPerson: "Personne à charge"
            },
            filters: {
                allUsers: "Tous les utilisateurs",
                allClients: "Tous les clients",
                allElementTypes: "Tous les types d'éléments"
            },
            eventName: {
                divisionCreated: "Division créée",
                divisionUpdated: "Division mise à jour",
                divisionArchived: "Division archivée",
                telusServiceDivisionUpdated: "Division mise à jour",
                telusDivisionSynchronized: "Division Telus synchronisée",
                telusDivisionSynchronizationFailed: "Échec de la synchronisation de la division Telus",
                classCreated: "Classe créée",
                telusClassSynchronized: "Classe Telus synchronisée",
                telusClassSynchronizationFailed: "Échec de la synchronisation de la classe Telus",
                clientCreated: "Client créé",
                clientUpdated: "Client mis à jour",
                clientInactivityPlanned: "Inactivité du client planifiée",
                clientInactivityCanceled: "Inactivité du client annulée",
                clientArchived: "Client archivé",
                coveragePeriodUpdated: "Période de couverture mise à jour",
                telusClientSynchronized: "Client Telus synchronisé",
                telusClientSynchronizationFailed: "Échec de la synchronisation du client Telus",
                dependentPersonCoverageCreated: "Couverture de la personne à charge créée",
                dependentPersonCoverageUpdated: "Couverture de la personne à charge mise à jour",
                dependentPersonUpdated: "Personne à charge mise à jour",
                dependentPersonArchived: "Personne à charge archivée",
                dependentPersonCoverageSyncActivated: "Synchronisation de la couverture de la personne à charge activée",
                dependentPersonSyncActivated: "Synchronisation de la personne à charge activée",
                telusDependentPersonCoverageSynchronized: "Couverture de la personne à charge Telus synchronisée",
                telusDependentPersonCoverageSynchronizationFailed: "Échec de la synchronisation de la couverture de la personne à charge Telus",
                memberUpdated: "Participant mis à jour",
                memberArchived: "Participant archivé",
                memberSyncActivated: "Synchronisation du participant activée",
                memberCoverageUpdated: "Couverture du participant mise à jour",
                memberCoverageArchived: "Couverture du participant archivée",
                memberCoverageSyncActivated: "Synchronisation de la couverture du participant activée",
                memberCoverageCreated: "Couverture du participant créée",
                telusMemberCoverageSynchronized: "Couverture du participant Telus synchronisée",
                telusMemberCoverageSynchronizationFailed: "Échec de la synchronisation de la couverture du participant Telus"
            },
            buttons: {
                applyFilter: "Appliquer les filtres",
                includeLinkedElements: "Inclure les éléments liés"
            },
            resyncButtonMsg: "Relancer la synchronisation",
            resyncMessages: {
                resyncSent: "Une tentative de relance a été lancée. Une nouvelle synchronisation va avoir lieu si l'élément est éligible.",
                resyncError: "La synchronisation sélectionnée n'est pas éligible à une relance.",
                resyncUnknownError: "Une erreur s'est produite, la relance de cette synchronisation n'est pas possible.",
            },
        },
    },
    clients: {
        title: "Clients",
        synchronizedWith: "Synchronisation via {syncType, select, TED_DESJARDINS {TED Desjardins} ELIGIBILITY {Telus Adjudicare}}",
        clientTypes: {
            brokerage: "Courtage",
            tpa: "TPA",
            tpp: "TPP",
            aso: "ASO"
        },
        invalidClientIdType: "L'identifiant du client que vous avez fourni n'est pas valide.",
        unauthorizedRedirectedExternalUser: "Les données que vous avez tenté de visualiser ne vous sont pas accessibles. Si la situation vous semble anormale, merci de contacter le support.",
        autoSaveActiveWarning: "Les changements apportés à ce champ sont automatiquement sauvegardés.",
        activationInfo:
            "Le changement de statut de MEV à <span class='green'>ACTIF</span> du client {client} a été réalisé avec <span class='green'>succès</span>. La prochaine période de facturation est celle de <span class='text-capitalize blue'>{bp}</span>, les factures rétroactives concerneront les périodes de facturation suivantes : <br/><br/>",
        synchronizationStatus: {
            nonSyncClient: "Le client n'est pas synchronisable.<br /><br />1- Il ne doit pas avoir le statut terminé.<br /><br />2- Il ne doit pas être archivé.<br /><br />3- Il doit avoir un choix de synchronisation API valide.",
            success: "Les informations du client sont synchronisées",
            inProgress: "Les informations du client sont en cours de synchronisation",
            failed: "Les informations du client ont échouées à être synchronisées",
            notSynced: "Les informations du client ne sont pas synchronisées",
            notSynchronizable: "Les informations du client ne sont pas synchronisables"
        },
        datatable: {
            actions: {
                add: "Ajouter un client",
                edit: "Modifier le client",
                view: "Visionner le client",
                includeArchivedClients: "Inclure les clients archivés",
                showOnly: "Afficher uniquement les",
                showConfirm: {
                    title: "Attention !",
                    message:
                        "Si vous fermez maintenant vos données ne seront pas sauvegardées. Souhaitez-vous continuer ?",
                },
            },
            columns: {
                billingPeriods: "Périodes de facturation",
                client: "Client",
                fullName: "Nom complet",
                name: "Nom",
                creationDate: "Date de création",
                status: "Statut",
                type: "Type d'assurance",
            },
            toolTips: {
                syncToolTipArchived: "Les clients archivées ne sont pas synchronisables.",
                syncToolTipWarning: "Le client n'est pas synchronisé.",
                syncToolTipWarningWithError: "Une ou plusieurs erreurs de synchronisation se sont produites : {error}",
                syncToolTip: "Le client est synchronisée.",
                syncToolTipStarted: "La synchronisation du client est en cours."
            },
        },
        followUps: {
            form: {
                contact: "Coordonnées de contact du client",
            },
        },
        form: {
            inactivationReasons: {
                boughtByClientOutsideMajor: "Acheté par autre client hors Major",
                boughtByMajorClient: "Acheté par autre client Major",
                leavingForCompetitor: "Va chez compétiteur",
                noLongerOffersGroupInsurance: "N'offre plus de collectif (trop cher)",
                eligibilityCriteriaTooSmall: "Critères d'éligibilité (groupe trop petit)",
                death: "Décès",
                bankruptcy: "Faillite",
                other: "Autre",
            },
            additionalConfigurations: {
                title: "Configurations additionnelles",
                tedDesjardins: "TED Desjardins",
                showDependentPersonFormula:
                    "Ajout d'une phrase précisant le calcul du montant de la prime de l'assuré(e) sur les <strong class='emphasis'>confirmations de couverture</strong>",
                shouldImportWithoutId: "Gestion des récupérations de <strong class='emphasis'>Codes Major</strong>",
                excludeNotifications: "Exclure des notifications de publications des factures",
                includeNotifications: "Inclure ce client aux notifications de publication des factures",
                isAutomaticMemberIdentifier: "Configuration des numéros uniques des participants",
                isSyncEligible: "Choix de synchronisation API",
                automaticOption: "Automatique",
                eligibility: "TELUS-ADJUDICARE",
                noSync: "Pas de synchronisation API",
                manualOption: "Manuel",
                admin: "Administrateur",
                fintech: "Fintech",
                defaultLength: "Longueur par défaut",
                customLength: "Longueur personnalisée",
                memberIdentifierLength: "Longueur du numéro unique",
                accountTypeSelection:
                    "Le type de compte doit être sélectionné pour avoir la possibilité de choisir la méthode de génération de membres",
                clientNumberExists:
                    "Le client avec le numéro de client saisi existe dans le système. Par conséquent, la méthode existante de génération de membres sera utilisée.",
                syncTypeWarning:
                    "Attention, si vous choisissez cette synchronisation, le client sera automatiquement créé dans le partenaire sélectionné, ses informations seront par la suite synchronisées automatiquement. Vous ne pourrez pas changer cette valeur suite à la création du client.",
                tedSyncWarning: "Attention, si vous choisissez cette synchronisation, veuillez vous assurer que le client existe déjà dans le système Desjardins. Une fois ce client ACTIF, il sera automatiquement intégré aux synchronisations par TED. Vous ne pourrez pas changer cette valeur suite à la création du client.",
            },
            block: {
                title: "Attribution du bloc",
            },
            complement: {
                title: "Complément",
                groupLabel: "Regroupement",
            },
            payment: {
                title: "Recevables",
            },
            acombaSettings: {
                acombaNumber: "Numéro de client (ACOMBA)",
                acombaProjectNumber: "Numéro de projet",
                title: "Configuration Acomba",
            },
            client: {
                bloc: "Bloc",
                clientType: "Type de client",
                noBlocs: "Aucun bloc",
                designator: "Sigle",
                billingPeriods: "Périodes de facturation",
                coverageWebsite: "URL de la couverture",
                name: "Nom usuel",
                fullName: "Nom complet",
                title: "Informations du client",
                status: "Statut",
                type: "Type d'assurance",
                ratePeriodType: "Configuration des taux",
                planInactive: "Plannifier le passage inactif du client",
                planInactiveEndDate: "Dernier jour d'activité",
                planInactiveCancel: "Annuler l'inactivité du client",
                planInactiveComplement: "Spécifiez",
                planInactiveReason: "Raison de l'inactivité",
                planInactiveReasonComplement: "Complément",
                planInactiveSuccess: "La planification d'inactivation du client a été sauvegardée",
                planInactiveCancelSuccess: "La planification d'inactivation du client a été annulée",
                planInactiveCancelProcess: "L'annulation de la planification de l'inactivation du client est en cours et peut prendre quelques secondes.",
                broker: {
                    associatedBrokerLimit: "Limite de 5 courtiers par client",
                    loading: "Chargement des courtiers...",
                },
                paymentmode: "Mode de paiement",
                accountType: "Type de compte",
                inactivePassageModalTitle: "Passage INACTIF du client",
                inactivePassageModalInfo:
                    "Pour passer le client INACTIF vous devez renseigner les informations suivantes.{br}Le dernier jour d'activité du client peut être une date dans le futur jusqu'à 3 mois après la date du jour.{br}" +
                    "Attention, ce client sera exclu de l’ensemble du processus de facturation une fois sa date de fin d'activité passée (sauf facture de terminaison).",
            },
            enum: {
                cheque: "Chèque",
                transfer: "Transfert",
                preauthorized_debit: "Débit préautorisé",
                gm: "Groupe Major",
                pm: "Plan Major",
            },
            sections: {
                generalInformation: "Informations générales",
                accounting: "Comptabilité",
                configuration: "Configuration",
                associatedBrokers: "Courtiers collaborateurs",
                coveragePeriods: "Périodes de couverture",
            },
            majorCost: {
                title: "Coût Major",
                fixedFees: "Frais fixes",
                variableFees: "Frais par participant ",
            },
            civicAddress: {
                title: "Adresse civique",
                address: "Adresse",
                city: "Ville",
                country: "Pays",
                provinceCode: "Province",
                postalCode: "Code postal",
                phoneNumber: "Numéro de téléphone",
                PMSalesTaxesInformations:
                    "La province du client détermine le taux des taxes applicables pour la facturation",
            },
            otherInformation: {
                effectiveDate: "Mise en vigueur",
                renewalDate: "Prochain Renouvellement",
                terminationDate: "Terminaison",
                clientNumber: "Numéro de client (Telus ou Desjardins)",
                clientNumberHeader: "Numéro de client",
                shortClientNumber: "Numéro",
                accountManager: "Gestionnaire de compte",
                shortAccountManager: "Gestionnaire",
                serviceRepresentative: "Représentant de service",
                shortServiceRepresentative: "Représentant",
                select: "Select",
                lastMemberGenerated: "Dernier participant créé",
                member: "Participant",
                uniqueNumber: "Numéro unique",
                createdBy: "Créé par",
                createdOn: "Date de création",
                createdAt: "Heure de création",
                division: "Division",
                status: "Statut",
                role: "Rôle",
            },
            coveragePeriods: {
                title: "Période de couverture",
                startDate: "Date de début",
                endDate: "Date de fin",
                renew: "Renouveler",
                renewCoverage: "Renouveler la période de couverture",
                durationWarning: "Attention, la durée de la période de couverture est inférieure à 1 an.",
            },
        },
        client: {
            errors: {
                fetchingError: "Impossible de récupérer les informations associées au client.",
            },
            categorisation: {
                saveBtn: "Sauvegarder",
                cancelBtn: "Annuler",
                categoryForm: {
                    title: "Catégorie du client",
                    clientCoveragesRedirection: "Détails des prix des couvertures",
                    form: {
                        missingFieldsError: "Un ou plusieurs champs obligatoires ne sont pas renseignés. Veuillez vérifier le formulaire",
                        clientType: "Type de client",
                        provenance: "Provenance",
                        reference: "Référence",
                        brokerName: "Nom du courtier",
                        requirementLevel: "Niveau d'exigence du service",
                        notoriety: "Notoriété",
                        vipClient: "Client VIP",
                        vipClassification: "Classification VIP",
                        retirementPlan: "Régime de retraite",
                        currentAssets: "Actifs en vigueur",
                        insurers: "Assureur(s)",
                        numberOfMembers: "Nombre de participants ACTIFS",
                        seller: "Nom du vendeur",
                        clientTypes: {
                            brokerage: "Courtage",
                            tpa: "TPA",
                            tpp: "TPP",
                            aso: "ASO",
                        },
                        provenanceTypes: {
                            direct: "Direct",
                            acquired: "Acquis",
                            broker: "Courtier",
                            brokerName: "Nom du courtier",
                            reference: "Référence",
                        },
                        requirementLevelTypes: {
                            low: "Faible",
                            medium: "Moyen",
                            high: "Élevé",
                        },
                        notorietyTypes: {
                            supplier: "Fournisseur",
                            partner: "Partenaire",
                            acquaintance: "Connaissance",
                            foreign: "Étranger",
                        },
                        vipClassificationTypes: {
                            premiumSize: "Taille primes",
                            partner: "Partenaire",
                            network: "Réseau",
                            acquaintance: "Connaissance",
                        },
                        retirementPlanTypes: {
                            yes: "Oui",
                            no: "Non",
                            prospect: "Prospect",
                        },
                        currentAssetTypes: {
                            lessThan250: "< 250 000",
                            between250And1m: "250 000 à 1 000 000",
                            moreThan1m: "1 000 000 +"
                        },
                        insurerTypes: {
                            multiInsurers: "Multi-Assureurs",
                            noInsurers: "Sans assureur"
                        }
                    }
                },
                financialForm: {
                    title: "Valeur financière",
                    form: {
                        numberOfActiveMembers: "Nombre de participants ACTIFS",
                        segmentation: "Segmentation",
                        marketSituation: "Situation du marché",
                        segmentationTypes: {
                            highIncome: "A - Client à revenu important",
                            middleIncome: "B - Client à revenu moyen",
                            lowIncome: "C - Client à faible revenu",
                            notBillable: "Client non facturable"
                        },
                        marketSituationTypes: {
                            growth: "Croissance",
                            stable: "Stabilité",
                            decrease: "Décroissance",
                            danger: "Danger",
                            forSale: "À vendre",
                            termination: "Terminaison",
                        },
                    },
                },
                otherForm: {
                    title: "Autres informations",
                    form: {
                        note: "Note",
                    },
                },
            },
            personalDataConfig: {
                title: "Configuration du formulaire de révision des données personnelles",
                personalData: "Données personnelles",
                subTitle:
                    "Cocher les informations personnelles qui apparaitront sur le formulaire et que le participant pourra contrôler",
                form: {
                    createForm: "Créer un formulaire de révision des données personnelles",
                    hasPersonalDataFormMessage: "Afficher un message configurable au dessus du formulaire",
                    hasPersonalDataPopupMessage:
                        "Afficher un popup d’information suite à la validation du code vérificateur par courriel",
                    firstName: "Prénom",
                    lastName: "Nom",
                    phoneNumber: "Numéro de téléphone",
                    email: "Courriel",
                    birthDate: "Date de naissance",
                    gender: "Sexe",
                    language: "Langue",
                    address: "Adresse",
                    city: "Ville",
                    country: "Pays",
                    province: "Province",
                    postalCode: "Code postal",
                    formVisualization: "Visualisation du formulaire",
                    formAccess: "Accéder au formulaire",
                    legalText: "TEXTE LEGAL",
                },
            },
            pages: {
                members: "Participants",
                billingPeriods: "Périodes de facturation",
                classes: "Classes",
                divisions: "Divisions",
                clientGuarantees: "Configuration de garanties",
                coverages: "Prix des couvertures",
                invoices: "Factures",
                configurations: "Configurations",
                withdrawal: "Formulaire de désistement",
                personalData: "Données personnelles",
                invoicingConfig: "Ajustements",
                contacts: "Contacts",
                classification: "Catégorisation",
                memberIdentifier: "Récup. du Code Major",
                reports: "Rapports",
                messages: "Messages",
                clientAttachments: "Dépôt de fichiers",
                bulkSalary: "Modification salaires",
                premiumSimulator: "Simulateur de primes",
                clientUsers: "Utilisateurs client",
                synchronizations: "Synchronisations",
                memberFiles: "Génération de fichiers",
                majorEnrolment: "Major enrôlement",
            },
            premiumSimulator: {
                form: {
                    multipleCoverageTypeSelection: "Vous venez de sélectionner des types de couverture différents pour les garanties de cette simulation. Merci de vous assurer que cette configuration est compatible avec le contrat d’assurance.",
                    noClassSelection: "Veuillez choisir une classe ou un participant pour afficher les garanties",
                    birthdate: "Date de naissance",
                    classId: "Classe",
                    divisionId: "Division",
                    employeeType: "Type d'employé",
                    employeeTypes: {
                        new: "Nouveau",
                        existing: "Existant",
                    },
                    generate: "Générer",
                    employeeDetails: "Informations de l'employé",
                    firstName: "Prénom",
                    language: "Langue",
                    lastName: "Nom",
                    member: "Employé",
                    memberCoverageType: "Type de couverture",
                    payrollFrequency: "Fréquence de paie",
                    provinceCode: "Province de résidence",
                    salary: "Salaire annuel",
                    select: "Sélectionner...",
                },
                payrollFrequencyTypes: {
                    WEEKLY: "52 périodes de paie",
                    BIWEEKLY: "26 périodes de paie",
                    SEMIMONTHLY: "24 périodes de paie",
                    MONTHLY: "Mensuel",
                    ANNUAL: "Annuel",
                },
                locales: {
                    "fr-CA": "Français",
                    "en-CA": "Anglais",
                },
                results: {
                    results: "Résultats de la simulation",
                    certificate: "Certificat",
                    date: "Date de la simulation",
                    error: "Une erreur s'est produite.",
                    export: "Exporter",
                    parameters: "Paramètres de la simulation",
                    print: "Imprimer",
                    summary: {
                        annual: "Sommaire annuel",
                        monthly: "Sommaire mensuel",
                        payPeriod: "Sommaire par période de paie",
                        employeePart: "Coût au salarié",
                        employerPart: "Coût à l'employeur",
                        subtotal: "Sous-total",
                        taxes: "Taxes",
                        total: "Total",
                    },
                    details: {
                        annual: "Détails annuels",
                        monthly: "Détails mensuels",
                        payPeriod: "Détails par période de paie",
                        description: "Description",
                        employeePart: "SAL",
                        employerPart: "EMP",
                        cost: "Coûts",
                        taxes: "Taxes",
                        subtotals: "Sous-totaux",
                        total: "TOTAL",
                    },
                    payrollDeductions: {
                        payrollDeductions: "Ventilation de la paie",
                        taxableBenefitsProvincial: "Avantages imposables au provincial",
                        taxableBenefitsFederal: "Avantages imposables au fédéral",
                        salaryDeductions: "Déductions salariales",
                        lifeInsurance: "Assurance vie",
                        groupInsurance: "Assurance groupe",
                        quebecHealthInsurance: "Maladie (QC)",
                        quebecHealthPremium: "Prime santé (QC) / Case 85",
                    },
                },
            },
            reports: {
                form: {
                    type: "Type",
                    generate: "Générer",
                    generating: "Génération en cours",
                    languageCode: "Langage du fichier",
                },
                taxBenefits: {
                    title: "Réduction des bénéfices imposable",
                    form: {
                        startingBillingPeriod: "Période de facturation de début",
                        endingBillingPeriod: "Période de facturation de fin",
                    },
                },
                coverageCertificate: {
                    title: "Rapport de certificats par type de couverture",
                    form: {
                        billingPeriod: "Période de facturation",
                        formatType: "Format",
                        type: {
                            province: "Provinces",
                            division: "Divisions",
                        },
                    },
                },
                coverageStatuses: {
                    title: "Rapport des statuts de couvertures",
                    form: {
                        billingPeriod: "Période de facturation",
                    },
                },
                dependentPersonCoveragesTerminations: {
                    title: "Âge maximal de personnes à charge",
                    form: {
                        billingPeriod: "Période de facturation",
                    },
                },
                ENELReport: {
                    // Maximum Sans-Preuve Admissble
                    title: "Rapport MSPA",
                },
                payrollDeductions: {
                    title: "Rapport de ventilation (paie)",
                    form: {
                        format: "Format",
                        WEEKLY: "Hebdomadaire",
                        BIWEEKLY: "Aux deux semaines (26 périodes de paie)",
                        SEMIMONTHLY: "Bimensuel (24 périodes de paie)",
                        MONTHLY: "Mensuel",
                        ANNUAL: "Annuel",
                        ANNUAL_WITH_CREDITS: "Annuel avec ajustements",
                        MONTHLY_WITH_CREDITS: "Mensuel avec ajustements",
                        year: "année",
                    },
                    validBilingPeriodsWarning: "Veuillez vous assurer que le client dispose de périodes de facturation et de factures valides, car les rapports ne peuvent pas être générés pour des factures GABARIT.",
                    validBilingPeriodsWarningPA: "Ce type de rapport nécessite d'avoir au moins une facture disponible.",
                },
                header: {
                    warningMessage:
                        "Attention, la période de facturation {billingPeriod} n'est pas finalisée. Les valeurs de ces rapports peuvent évoluer.",
                },
            },
            withdrawalPeriods: "{periods, plural, one {Période} other {Périodes}} de désistement",
            processSync: {
                notificationsBoard: {
                    title: "Journal des synchronisations",
                    details: {
                        titles: {
                            adjudicareSynchronization: "Synchronisation Adjudicare"
                        },
                        messages: {
                            notificationSyncSuccessParticipant: "Les informations pour le participant {member} sont synchronisées dans Telus Adjudicare",
                            notificationSyncFailParticipant: "Les informations pour le participant {member} ne sont pas synchronisées dans Telus Adjudicare",
                            notificationSyncInProgressParticipant: "Les informations pour le participant {member} sont en cours de synchronisation dans Telus Adjudicare",
                            notificationSyncSuccessPAC: "Les informations pour la personne à charge {PAC} sont synchronisées dans Telus Adjudicare",
                            notificationSyncFailPAC: "Les informations pour la personne à charge {PAC} ne sont pas synchronisées dans Telus Adjudicare",
                            notificationSyncInProgressPAC: "Les informations pour la personne à charge {PAC} sont en cours de synchronisation dans Telus Adjudicare",

                            notificationSyncSuccessDivision: "Les informations pour la division {division} sont synchronisées dans Telus Adjudicare",
                            notificationSyncFailDivision: "Les informations pour la division {division} ne sont pas synchronisées dans Telus Adjudicare",
                            notificationSyncInProgressDivision: "Les informations pour la division {division} sont en cours de synchronisation dans Telus Adjudicare",

                            notificationSyncSuccessClient: "Les informations pour le client {client} sont synchronisées dans Telus Adjudicare",
                            notificationSyncFailClient: "Les informations pour le client {client} ne sont pas synchronisées dans Telus Adjudicare",
                            notificationSyncInProgressClient: "Les informations pour le client {client} sont en cours de synchronisation dans Telus Adjudicare",

                            notificationSyncSuccessClass: "Les informations pour la classe {class_} sont synchronisées dans Telus Adjudicare",
                            notificationSyncFailClass: "Les informations pour la classe {class_} ne sont pas synchronisées dans Telus Adjudicare",
                            notificationSyncInProgressClass: "Les informations pour la classe {class_} sont en cours de synchronisation dans Telus Adjudicare"
                        },
                        messagesWithUsers: {
                            notificationSyncSuccessParticipant: "Les informations pour le participant {member} sont synchronisées dans Telus Adjudicare suite à une action de {user}",
                            notificationSyncFailParticipant: "Les informations pour le participant {member} ne sont pas synchronisées dans Telus Adjudicare suite à une action de {user}",
                            notificationSyncInProgressParticipant: "Les informations pour le participant {member} sont en cours de synchronisation dans Telus Adjudicare suite à une action de {user}",
                            notificationSyncSuccessPAC: "Les informations pour la personne à charge {PAC} sont synchronisées dans Telus Adjudicare suite à une action de {user}",
                            notificationSyncFailPAC: "Les informations pour la personne à charge {PAC} ne sont pas synchronisées dans Telus Adjudicare suite à une action de {user}",
                            notificationSyncInProgressPAC: "Les informations pour la personne à charge {PAC} sont en cours de synchronisation dans Telus Adjudicare suite à une action de {user}",

                            notificationSyncSuccessDivision: "Les informations pour la division {division} sont synchronisées dans Telus Adjudicare suite à une action de {user}",
                            notificationSyncFailDivision: "Les informations pour la division {division} ne sont pas synchronisées dans Telus Adjudicare suite à une action de {user}",
                            notificationSyncInProgressDivision: "Les informations pour la division {division} sont en cours de synchronisation dans Telus Adjudicare suite à une action de {user}",

                            notificationSyncSuccessClient: "Les informations pour le client {client} sont synchronisées dans Telus Adjudicare suite à une action de {user}",
                            notificationSyncFailClient: "Les informations pour le client {client} ne sont pas synchronisées dans Telus Adjudicare suite à une action de {user}",
                            notificationSyncInProgressClient: "Les informations pour le client {client} sont en cours de synchronisation dans Telus Adjudicare suite à une action de {user}",

                            notificationSyncSuccessClass: "Les informations pour la classe {class_} sont synchronisées dans Telus Adjudicare suite à une action de {user}",
                            notificationSyncFailClass: "Les informations pour la classe {class_} ne sont pas synchronisées dans Telus Adjudicare suite à une action de {user}",
                            notificationSyncInProgressClass: "Les informations pour la classe {class_} sont en cours de synchronisation dans Telus Adjudicare suite à une action de {user}"
                        },
                    },
                    actions: {
                        seeMore: "Voir plus",
                        reload: "Recharger"
                    },
                    filters: {
                        onlyMyModifications: "Voir uniquement mes modifications",
                        onlyErrors: "Voir uniquement les erreurs"
                    },
                },
                form: {
                    synchronize: "Synchroniser",
                    syncSentSuccess: "La synchronisation a bien été lancée.",
                    syncSentFailure: "La synchronisation n'a pas pu être lancée.",
                    fetchingWarningsMessage: "En cours de vérification...",
                    warnings: {
                        dependentPersonCoverageOverlapWarning: "Une ou plusieurs couvertures de personne à charge associées à cette période de facturation ont possiblement été rendues identiques aux autres couvertures liées. Il est possible que la synchronisation entraine un chevauchement de couvertures dans Adjudicare bloquant les réclamations. Avant de lancer la synchronisation, merci de vérifier que les dates des couvertures suivantes sont compatibles avec celles dans Adjudicare. Cliquer sur Confirmer lancera une synchronisation Adjudicare.",
                        memberCoverageOverlapWarning: "Une ou plusieurs couvertures de participant associées à cette période de facturation ont possiblement été rendues identiques aux autres couvertures liées. Il est possible que la synchronisation entraine un chevauchement de couvertures dans Adjudicare bloquant les réclamations. Avant de lancer la synchronisation, merci de vérifier que les dates des couvertures suivantes sont compatibles avec celles dans Adjudicare. Cliquer sur Confirmer lancera une synchronisation Adjudicare.",
                    }
                },
                datatable: {
                    title: "Synchronisations",
                    statusTypes: {
                        init: "Intialisé",
                        started: "Commencé",
                        success: "Succès",
                        failure: "Échec",
                        incomplete: "Incomplet",
                    },
                    billingPeriod: "Période de facturation",
                    status: "Statut",
                    memberSynchronizedCoverages: "Couvertures participants synchronisées",
                    dependentSynchronizedCoverages: "Couvertures PàC synchronisées",
                    startedAt: "Date de début",
                    duration: "Durée",
                },
                errorIdentifiers: {
                    unidentifiedCommunicationError:
                        "Une erreur de communication avec Telus a eu lieu. Elle peut être causée par une surcharge de leur service. Merci de patienter quelques minutes avant de lancer une prochaine synchronisation. Si le problème persiste, merci de contacter le support.",
                    connectionAborted:
                        "Une erreur Telus est survenue. Elle peut être causée par une surcharge de leur service. Merci de patienter quelques minutes avant de lancer une prochaine synchronisation.",
                    certUnidentifiedError: "Une analyse de configuration est requise pour le participant{memberIdentifier, select, NONE {} other {: }}{memberIdentifier, select, NONE {} other {{memberIdentifier}}}.",
                    certUnexpectedError:
                        "Une erreur Telus non identifiée est survenue pour le participant {memberIdentifier}.",
                    certInvalidCertNumber: "Un participant avec l'identifiant {memberIdentifier} est déjà existant.",
                    certInvalidDivNumber:
                        "La division possédant le numéro {elementId} n'a pas été trouvée dans Telus pour le participant {memberIdentifier}.",
                    certInvalidClassNumber:
                        "La classe possédant le numéro {elementId} n'a pas été trouvée dans Telus pour le participant {memberIdentifier} ou n'est pas trouvée dans la division associée.",
                    certInvalidPostalCode: "Le code postal du participant {memberIdentifier} n'est pas valide.",
                    certMemberIdentifierSpace: "L'identifiant du participant {memberIdentifier} comporte un espace. Veuillez corriger son identifiant.",
                    certMissingAddressElement:
                        "L'adresse du participant {memberIdentifier} n'est pas valide. Vérifier les champs adresse, ville et code postal.",
                    certInvalidDate: "L'information {field} n'est pas valide pour le participant {memberIdentifier}. La date de naissance dans le futur n’est pas acceptée par Telus.",
                    certInvalidTerminationDate:
                        "La date de fin de la couverture du participant {memberIdentifier} ne doit pas se situer avant sa date de début.",
                    certMissingBirthdate: "La date de naissance du participant {memberIdentifier} doit être renseignée.",
                    certInvalidCoverageStartDate:
                        "Le participant {memberIdentifier} a une couverture avec une date de début antérieure à la date de début de la classe présente dans Telus.",
                    certMissingClientNumber: "Le numéro de client (Telus) du participant {memberIdentifier} n'est pas renseigné.",
                    certInvalidClientNumber: "Le numéro de client (Telus) du participant {memberIdentifier} est invalide.",
                    certMissingProvince: "La province du participant {memberIdentifier} n'est pas renseignée.",
                    certMissingCountry: "Le pays du participant {memberIdentifier} n'est pas renseigné.",
                    certWrongCertNumber: "Le numéro unique du participant {memberIdentifier} contient des caractères non valides (caractères spéciaux ou accents).",
                    certInvalidBankCode: "Le numéro d'institution bancaire du participant {memberIdentifier} est invalide.",
                    certInvalidEffectiveDate: "La date de début de couverture du participant {memberIdentifier} est invalide.",
                    certInvalidAccountNumber: "Le numéro de compte bancaire du participant {memberIdentifier} est invalide.",
                    certInvalidBranchNumber: "Le numéro de transit du participant {memberIdentifier} est invalide.",
                    certMissingAccountNumber: "Le numéro de compte bancaire du participant {memberIdentifier} est manquant.",
                    certMissingBranchTransitNumber: "Le numéro de transit du participant {memberIdentifier} est manquant.",
                    certMissingBankCode: "Le numéro d'institution bancaire du participant {memberIdentifier} est manquant.",
                    certMissingMemberIdentifier: "Le participant ne possède pas de numéro d'identifiant.",
                    certInvalidLengthFirstName: "Le prénom fourni dépasse la limite de 50 caractères pour la synchronisation Telus.",
                    certInvalidLengthLastName: "Le nom de famille fourni dépasse la limite de 50 caractères pour la synchronisation Telus.",
                    certInvalidLengthPhoneNumber: "Le numéro de téléphone fourni dépasse la limite de 30 caractères pour la synchronisation Telus.",
                    certInvalidLengthEmailAddress: "Le courriel fourni dépasse la limite de 100 caractères pour la synchronisation Telus.",
                    certInvalidLengthCity: "La ville fournie dépasse la limite de 50 caractères pour la synchronisation Telus.",
                    certInvalidLengthMemberIdentifier: "Le numéro unique de participant fourni dépasse la limite de 15 caractères pour la synchronisation Telus.",
                    certDivisionNotSynchronized: "La division utilisée pour la synchronisation de la couverture n'est pas correctement synchronisée.",
                    certEmptyExternalClassNumber: "La couverture du participant {memberIdentifier, select, NONE {} other {{memberIdentifier}}} {startDate, select, null {} other {débutant le {startDate} }}est associée à une classe non synchronisée.",
                    certMemberIdentifierTrailingZerosError: "Le numéro unique {memberIdentifier} existe déjà dans Adjudicare. Les numéros ayant des zéros devant les numéros d'identifiants sont considérés identiques à ceux sans zéros. (par exemple, « 00532 » est identique à « 532 »).",
                    invalidDependent: "Une personne à charge du participant {memberIdentifier} est déjà existante.",
                    depUnexpectedError: "Une erreur Telus non identifiée est survenue pour une personne à charge du participant {memberIdentifier}.",
                    dependentInvalidPostalCode: "Une personne à charge du participant {memberIdentifier} possède un code postal non valide. Vérifier le champ du membre associé.",
                    dependentMissingAddressElement: "Une personne à charge du participant {memberIdentifier} possède une adresse non valide. Vérifier les champs adresse, ville et code postal du membre associé.",
                    dependentInvalidDate: "Une personne à charge du participant {memberIdentifier} possède une date non valide pour le champ {field}. La date de naissance dans le futur n’est pas acceptée par Telus.",
                    dependentInvalidInfos: "Une personne à charge du participant {memberIdentifier} possède les mêmes informations date de naissance et prénom qu'une autre personne à charge.",
                    dependentMissingBirthdate: "Une personne à charge du participant {memberIdentifier} ne possède pas de date de naissance.",
                    dependentInvalidCoverageStartDate: "Une personne à charge du participant {memberIdentifier} a une couverture avec une date de début antérieure à la date de début de la classe présente dans Telus.",
                    dependentMissingProvince: "La province du participant {memberIdentifier}, utilisé pour une personne à charge, n'est pas renseignée.",
                    dependentMissingCountry: "Le pays du participant {memberIdentifier}, utilisé pour une personne à charge, n'est pas renseigné.",
                    dependentMissingClientNumber: "Le numéro de client (Telus) d'une personne à charge du participant {memberIdentifier} n'est pas renseigné.",
                    dependentMissingDivisionElement: "La date de début de couverture de la personne à charge n’est pas couverte par une couverture de participant.",
                    dependentInvalidClientNumber: "Le numéro de client (Telus) d'une personne à charge du participant {memberIdentifier} est invalide.",
                    dependentInvalidDivNumber: "La division possédant le numéro {elementId} n'a pas été trouvée pour une personne à charge du participant {memberIdentifier}.",
                    dependentInvalidCertNumber: "Un participant avec l'identifiant {memberIdentifier} n'a pas été trouvé dans Telus pour une personne à charge.",
                    dependentInvalidTerminationDate: "La date de fin de la couverture d'une personne à charge du participant {memberIdentifier} ne doit pas se situer avant sa date de début.",
                    dependentInvalidEffectiveDate: "La date de début de la couverture d'une personne à charge du participant {memberIdentifier} ne doit pas se situer avant la date de début de couverture du membre dans Telus.",
                    dependentMultipleSpouse: "Le participant {memberIdentifier} a plusieurs conjoints en même temps.",
                    dependentWrongCertNumber:
                        "Le numéro unique d'un participant d'une personne à charge est incorrect. Le numéro unique {memberIdentifier} contient des caractères non valides (caractères spéciaux ou accents).",
                    dependentMissingMemberIdentifier: "Le numéro unique du participant associé à la personne à charge est vide. Veuillez renseigner son numéro unique.",
                    dependentInvalidLengthMemberIdentifier: "Le numéro unique ({memberIdentifier}) du participant associé à la personne à charge dépasse la limite (15 caractères). Veuillez corriger son numéro unique.",
                    dependentMemberIdentifierSpace: "Le numéro unique ({memberIdentifier}) du participant associé à la personne à charge contient un espace. Veuillez corriger son numéro unique.",
                    dependentInvalidLengthFirstName: "Le prénom fourni dépasse la limite de 50 caractères pour la synchronisation Telus.",
                    dependentInvalidLengthLastName: "Le nom de famille fourni dépasse la limite de 50 caractères pour la synchronisation Telus.",
                    divisionUnexpectedError: "Une erreur Telus non identifiée est survenue.",
                    divisionInvalidEffectiveDate:
                        "La date de début du client (début de la première période de couverture enregistrée) diffère de celle indiquée en Telus. Veuillez la mettre à jour ou contacter le support pour la corriger.",
                    divisionMissingClientNumber:
                        "Le numéro de client (Telus) n'est pas renseigné. Veuillez le renseigner ou contacter le support pour le corriger.",
                    divisionInvalidClientNumber:
                        "Le numéro de client (Telus) {elementId} attribué à ce client n'est pas valide. Veuillez le mettre à jour ou contacter le support pour le corriger.",
                    divisionInvalidDivisionNumber:
                        "Le numéro de division Telus {elementId} attribué à la division n'est pas valide. Veuillez le mettre à jour ou contacter le support pour le corriger.",
                    divisionInvalidLengthDivisionNumber: "Le numéro de division Telus fourni {elementId} dépasse la limite de 9 caractères pour la synchronisation avec Telus.",
                    divisionInvalidNonNumericDivisionNumber: "Le numéro de division Telus {elementId} contient des caractères non numériques.",
                    divisionUnexpectedDivisionId:
                        "Le numéro de division partenaire {elementId} enregistré dans Telus est différent de celui du système. Veuillez contacter le support pour le corriger.",
                    divisionNonCanadianProvince:
                        "Une province non canadienne est attribuée dans l'adresse du client.",
                    divisionUnidentifiedError: "Une erreur non identifiée est survenue.",
                    divisionMissingProvince: "La province du client n'est pas renseignée.",
                    divisionInvalidThirdPartyNumber: "Le numéro de la division n'est pas valide.",
                    fields: {
                        startDate: "Date de début de couverture",
                        endDate: "Date de fin de couverture",
                        birthdate: "Date de naissance",
                        city: "Ville",
                        postcd: "Code postal",
                    },
                    clientInvalidLengthCity: "La ville fournie dépasse la limite de 50 caractères requise pour la synchronisation avec Telus.",
                    clientInvalidLengthName: "Le nom fourni dépasse la limite de 100 caractères requise pour la synchronisation avec Telus.",
                    clientInvalidLengthAdminContactPhoneNumber: "Le numéro de téléphone du contact administratif fourni dépasse la limite de 30 caractères pour la synchronisation Telus.",
                    clientInvalidLengthAdminContactEmailAddress: "Le courriel du contact administratif fourni dépasse la limite de 100 caractères pour la synchronisation Telus.",
                    clientInvalidLengthAdminContactFullName: "Le nom complet du contact administratif fourni dépasse la limite de 50 caractères pour la synchronisation Telus.",
                    clientInvalidClientNumber: "Le numéro de client est invalide.",
                    clientInvalidInfos: "Les informations du client dans le champ {field} ne sont pas valides.",
                    clientInvalidInfosGeneric: "Les informations du client sont invalides, merci de les vérifier. Veuillez contacter le support technique si le problème persiste.",
                    clientMissingName: "Le nom du client n'est pas attribué.",
                    clientMissingAddress: "L'adresse du client n'est pas attribuée.",
                    clientMissingCity: "La ville du client n'est pas attribuée.",
                    clientMissingPostalCode: "Le code postal du client n'est pas attribué.",
                    clientMissingCountryCode: "Le pays du client n'est pas attribué.",
                    clientMissingCoveragePeriodStartDate: "La date de début de la période de couverture n'est pas attribuée au client.",
                    clientUnexpectedError: "Une erreur Telus non identifiée est survenue.",
                    clientUnidentifiedError: "Une erreur inconnue s'est produite.",
                    classUnexpectedError: "Une erreur Telus non identifiée est survenue.",
                    classMissingClientNumber: "Le numéro de client (Telus) n'est pas renseigné.",
                    classMissingClassNumber: "Le numéro de la classe n'est pas renseigné.",
                    classMissingDivisionNumber: "Le numéro de division Telus n'est pas renseigné dans la division associée.",
                    classUnidentifiedError: "Une erreur inattendue s'est produite. Veuillez vous assurer que le client et la division associée sont correctement synchronisés avec Telus. Si la synchronisation est confirmée et que le problème persiste, Veuillez contacter le support pour obtenir de l'assistance.",
                    classInvalidEffectiveDate:
                        "La date de début du client (début de la première période de couverture enregistrée) diffère de celle indiquée dans Telus. Veuillez la mettre à jour ou contacter le support pour la corriger.",
                },
                coverageStartDateWarning: "Cette couverture existe déjà dans Adjudicare. La mise à jour des informations de la couverture dans Telus-Adjudicare peut prendre un délai de 24 à 48h, les réclamations peuvent être bloquées le temps de cette mise à jour.",
                inProgressSyncs: "Synchronisations en cours",
                synchronize: "Synchroniser",
                synchronizedMemberCoverages: "Couvertures participants synchronisées",
                synchronizedDepCoverages: "Couvertures personnes à charge synchronisées",
                errors: {
                    technicalError: "Une erreur technique est survenue.",
                    processSyncLimitError:
                        "Vous ne pouvez pas lancer plus d'une synchronisation à la fois pour un client.",
                },
            },
        },
        insuranceStatus: {
            fully: "Pleinement assuré",
            self: "Autoassuré",
        },
        ratePeriodTypes: {
            month: "Mensuelle",
            billingPeriod: "Par période de facturation",
        },
        header: {
            group: "Groupe",
            extension: "poste"
        },
    },
    header: {
        goToV2: "Nouvelle interface",
    },
    common: {
        blank: " ",
        na: "N/A",
        nd: "N/D",
        add: "Ajouter",
        archive: "Archiver",
        unarchive: "Désarchiver",
        return: "retourner",
        continue: "Continuer",
        cancel: "Annuler",
        close: "Fermer",
        confirm: "Confirmer",
        delete: "Supprimer",
        download: "Télécharger",
        downloadFinished: "Téléchargement terminé",
        edit: "Modifier",
        editSelection: "Modifier la sélection",
        confirmationWarningTitle: "Attention !",
        showSelectedCheckboxes:
            "{showSelectedCheckboxes} {showSelectedCheckboxes, plural, one {élément} other {éléments}} {showSelectedCheckboxes, plural, one {sélectionné} other {sélectionnés}}",
        modifyNumberCheckBoxUsed:
            "Modifier la sélection de ({showSelectedCheckboxes}) {showSelectedCheckboxes, plural, one {élément} other {éléments}}",
        modifySelectionElement:
            " Attention les modifications seront reportées sur {showSelectedCheckboxes, plural, one {le} other {les}} {showSelectedCheckboxes, plural, one {} other {{showSelectedCheckboxes}}} {showSelectedCheckboxes, plural, one {suivi sélectionné} other {suivis sélectionnés}}",
        filters: {
            emptyLabel: "Aucun résultat.",
            promptText: "Tapez pour rechercher...",
            searchText: "Recherche...",
        },
        generate: "Générer",
        generating: "Génération en cours...",
        loading: "En cours de chargement...",
        logout: "Déconnexion",
        reset: "Réinitialiser",
        save: "Sauvegarder",
        select: "Sélectionner...",
        noResults: "Aucun résultat",
        view: "Visionner",
        yes: "Oui",
        no: "Non",
        ok: "Ok",
        toDate: "à",
        month: {
            january: "Janvier",
            february: "Février",
            march: "Mars",
            april: "Avril",
            may: "Mai",
            june: "Juin",
            july: "Juillet",
            august: "Août",
            september: "Septembre",
            october: "Octobre",
            november: "Novembre",
            december: "Décembre",
        },
        provinces: {
            QC: "Québec",
            ON: "Ontario",
            AB: "Alberta",
            BC: "Colombie-Britannique",
            MB: "Manitoba",
            NB: "Nouveau-Brunswick",
            NL: "Terre-Neuve-et-Labrador",
            NS: "Nouvelle-Écosse",
            NT: "Territoires du Nord-Ouest",
            NU: "Nunavut",
            PE: "Île-du-Prince-Édouard",
            SK: "Saskatchewan",
            YT: "Yukon",
        },
        year: "{number} An",
        months: "{number} Mois",
        weeks: "{number} Semaines",
        unknown: "Inconnu",
        reservedField: "Ce champ est réserve au Groupe Major",
        options: "Options",
        optional: "(Facultatif)",
        logoutError: "Une erreur s'est produite lors de la déconnexion. Veuillez contacter le support.",
    },
    configurationsForm: {
        configurations: "Configurations",
        authorizationCode: "Code d'autorisation",
        enterAuthorizationCode: "Entrer le code d'autorisation",
        lastModification: "Dernière modification le {modifiedOn, date, long} par {modifiedBy}",
        newMemberApprovalUser: "Admin des nouveaux participants",
    },
    mfaPreferenceForm: {
        mfaPreference: "Préférence MFA",
        mfaInfo:
            "Veuillez sélectionner votre préférence pour la réception du code d'authentification multi-facteur. Ce code vous sera demandé à chaque connexion à l'application.",
        successfullUpdate: "Votre modification a bien été prise en compte",
    },
    datatable: {
        actions: "Actions",
        select: "Tout sélectionner",
        noData: "Aucune donnée à afficher",
        refreshData: "Actualiser les données",
        position: {
            results: "Résultats",
            total: "total",
        },
        search: {
            placeholder: "Rechercher...",
        },
    },
    dependentCoverages: {
        datatable: {
            actions: {
                add: "Ajouter une période de couverture",
                edit: "Modifier la période de couverture",
                view: "Visionner la période de couverture",
            },
            columns: {
                date: "Date",
                period: "Période de couverture",
                periodFrom: "À partir du ",
                today: "aujourd'hui",
                name: "Nom",
                relation: "Relation",
                gender: "Sexe",
                birthdate: "Date de naissance",
                smoker: "Fumeur",
                student: "Étudiant",
                status: "Statut",
                sync: "Sync",
            },
            student: {
                yes: "Oui",
                no: "Non",
            },
            toolTips: {
                syncToolTipWarning: "La couverture de la personne à charge n'est pas synchronisée.",
                syncToolTipWarningWithError: "Une ou plusieurs erreurs de synchronisation se sont produites : {error}",
                syncToolTip: "La couverture de la personne à charge est synchronisée.",
                syncToolTipStarted: "La couverture est en cours de synchronisation.",
                relatedCoverageToolTipWarning: "Une couverture d'une session précédente a été synchronisée plus récemment que celle-ci. Les dates de couvertures présentes dans Telus Adjudicare peuvent ne pas être à jour."
            },
        },
        form: {
            billingPeriod: "Période de facturation",
            startDate: "Date de début",
            endDate: "Date de fin",
            status: "Statut",
            inactivityReason: "Raison de l'inactivité",
            inactivityReasonDate: "Date du désistement",
            inactivityReasonDetails: "Spécifiez",
            noBillingPeriod: "Aucune période de facturation disponible pour la couverture de la personne à charge. Veuillez vérifier si le client a des périodes et que la dernière période n’est pas déjà attribuée à une autre couverture de la personne à charge."
        },
        errors: {
            invalidCreateDisabilityStartDateError: "La date de début d'invalidité de la personne à charge se situe pendant une couverture. Veuillez choisir une date valide, puis créer la couverture, ou contacter le support pour obtenir de l'aide",
            invalidUpdateDisabilityStartDateError: "La date de début d'invalidité de la personne à charge se situe pendant une couverture. Veuillez choisir une date valide, puis mettre à jour la couverture, ou contacter le support pour obtenir de l'aide",
            conflictedDatesError: "Les dates de couverture choisies chevauchent celles d'autres couvertures de personnes à charge. Veuillez vérifier les dates et les modifier si nécessaire."
        }
    },
    dependents: {
        title: "Personnes à charge",
        datatable: {
            actions: {
                add: "Ajouter une personne à charge",
                edit: "Modifier la personne à charge",
                includeArchivedDependents: "Inclure les personnes à charge archivées",
                view: "Visionner la personne à charge",
            },
            columns: {
                name: "Nom",
                relation: "Relation",
                gender: "Sexe",
                birthdate: "Date de naissance",
                smoker: "Fumeur",
                sync: "Sync",
                disability: "Handicap",
            },
            disability: {
                yes: "Oui",
                no: "Non",
            },
            toolTips: {
                dependentNoSync: "La personne à charge n'est pas synchronisable.<br/><br/>1- La PàC ne doit pas être archivée.<br/><br/>2- La PàC doit posséder au moins une couverture.",
                syncToolTipWarning: "La personne à charge n'est pas synchronisée.",
                syncToolTip: "La personne à charge est synchronisée.",
                syncToolTipStarted: "La synchronisation de la personne à charge est en cours.",
                syncToolTipWarningWithError: "Une ou plusieurs erreurs de synchronisation se sont produites : {error}"
            },
            errors: {
                invalidDisabilityStartDateError: "La date de début de l'invalidité ne peut pas être pendant une couverture active d'une personne à charge. Veuillez choisir une date valide ou contacter le support si vous avez besoin d'aide.",
            }
        },
        form: {
            firstName: "Prénom",
            lastName: "Nom de famille",
            relation: "Relation",
            gender: "Sexe",
            birthdate: "Date de naissance",
            smoker: "Fumeur",
            isStudent: "Étudiant(e)",
            isDisabled: "Handicap",
            disabilityStartDate: "Date de début du handicap",
            disabilityStartDateHint: "La date ne peut pas être avant la date de naissance et doit être hors couverture ou le jour de début d'une couverture de la personne à charge.",
        },
        nav: {
            all: "Toutes les p.à.c.",
            coverages: "Couvertures",
        },
        relations: {
            spouse: "Conjoint(e)",
            child: "Enfant",
        },
        errors: {
            invalidDisabilityStartDateError: "La date de début de l'invalidité ne peut pas être pendant une couverture d'une personne à charge. Veuillez choisir une date valide ou contacter le support si vous avez besoin d'aide.",
        }
    },
    divisions: {
        title: "Divisions",
        datatable: {
            actions: {
                add: "Ajouter une division",
                edit: "Modifier la division",
                view: "Visionner la division",
                includeArchivedDivisions: "Inclure les divisions archivées",
            },
            columns: {
                division: "Division",
                status: "Statut",
                sync: "Sync.",
                externalDivisionNumber: "Numéro de division Telus ou Desjardins",
            },
            toolTips: {
                syncToolTipArchived: "Les divisions archivées ne sont pas synchronisables.",
                syncToolTipWarning: "La division n'est pas synchronisée.",
                syncToolTipWarningWithError: "Une ou plusieurs erreurs de synchronisation se sont produites : {error}",
                syncToolTip: "La division est synchronisée.",
                syncToolTipStarted: "La synchronisation de la division est en cours."
            },
            syncDisplayStatus: {
                success: "Toutes les divisions sont synchronisées",
                warning: "Certaines divisions ne sont pas synchronisées",
                danger: "Aucune division n’est synchronisée",
            }
        },
        form: {
            name: "Nom de la division",
            divisionNumber: "Numéro de division",
            externalDivisionNumber: "Numéro de division Telus ou Desjardins",
            province: "Province",
            syncDisplayStatus: {
                success: "La division est synchronisée.",
                started: "La synchronisation de la division est en cours.",
                dangerErrors: "Une ou plusieurs erreurs de synchronisation se sont produites :",
                danger: "La division n'est pas synchronisée.",
            }
        },
        errors: {
            divisionActiveCoverageError: "La division possède une ou plusieurs couverture(s) de participant active(s), ce qui bloque l'archivage.",
            divisionActiveCoverageAndClassError: "La division possède une ou plusieurs couverture(s) de participant et classe(s) active(s), ce qui bloque l'archivage.",
            divisionActiveClassError: "La division possède une ou plusieurs classe(s) active(s) ce qui bloque l'archivage."
        }
    },
    download: {
        title: "Télécharger un fichier",
        form: {
            languageCode: "Langage du fichier",
        },
        errors: {
            noCoverageFound: "Le participant sélectionné n'a pas de couverture",
            Unauthorized: "Vous n'êtes pas autorisé à télécharger ce fichier"
        },
    },
    error: {
        403: {
            title: "403 Non autorisé",
            link: "Go back to homepage",
        },
        404: {
            title: "404 Page non trouvée",
            link: "Retour à la page d'accueil",
        },
        noData: {
            title: "Aucun client associé",
            description: "Votre compte utilisateur n'est associé à aucun client. Veuillez contacter votre gestionnaire de compte si cette situation ne semble pas normale.",
            link: "Recharger"
        },
        unknown: "Une erreur inattendue s'est produite",
    },
    followUps: {
        title: "Suivis",
        pages: {
            list: "Suivis {followUpsCount, plural, =0 {} other {({followUpsCount})}}",
            messages: "Messages {messagesCount, plural, =0 {} other {({messagesCount})}}",
        },
        list: {
            datatable: {
                actions: {
                    add: "Ajouter un suivi",
                    edit: "Modifier le suivi",
                    view: "Visionner le suivi",
                    includeClosedFollowUps: "Afficher les suivis ouverts et fermés",
                    showOnly: "Afficher uniquement les",
                    followUpTypes: {
                        title: "Suivi",
                        note: "Note avec suivi",
                        incidentFollowUp: "Suivi d'incident",
                        specialModification: "Modification spéciale",
                    },
                    showConfirm: {
                        title: "Attention !",
                        message:
                            "Si vous fermez maintenant vos données ne seront pas sauvegardées. Souhaitez-vous continuer ?",
                    },
                },
                columns: {
                    priority: "Priorité",
                    creation: "Création",
                    deadline: "Échéance",
                    description: "Description",
                    creator: "Createur",
                    client: "Client",
                    member: "Participant",
                    assigned: "Assigné(e)",
                    category: "Catégorie",
                    status: "Statut",
                },
                recipient: "{status, select, OPEN{de} CLOSED{par}} {recipientName}",
            },
        },
        filters: {
            all: "Tous les suivis",
            toMe: "Les suivis qui me sont assignés",
            fromMe: "Mes suivis créés ou transférés",
            member: "Filtre participant",
        },
    },
    gender: {
        female: "Femme",
        male: "Homme",
        nd: "N/D",
    },
    importExport: {
        title: "Importation / Exportation",
        actions: {
            import: "Importer",
            export: "Exporter",
            publish: "Publier",
        },
        exportManyInvoices: {
            subTitle: "Exportation et publication des factures de clients corporatifs",
            form: {
                blocs: "Blocs",
                clients: "Clients",
                period: "Période",
                selectType: "Type de sélection",
            },
            messages: {
                error: "Une erreur s'est produite :",
                errors: {
                    BAD_REQUEST: "Erreur lors du traitement de la requête",
                    NOTHING_TO_PUBLISH: "Il n'y a pas de facture à publier avec les critères actuels.",
                    UNKNOWN_ERROR: "Erreur inconnue.",
                },
                success: "La requête a été traitée avec succès :",
                successes: {
                    export: "Un courriel contenant les factures sera envoyé dans les prochaines 12 heures.",
                    publish: "Les factures ont été publiées.",
                },
                validation: {
                    clientSelection: "Vous devez sélectionner au moins un client lorsqu'en mode inclusion",
                },
            },
            export: {
                modal: {
                    description:
                        "Seules les factures non générées seront générées. Cependant, toutes les factures apparaissant dans la liste ci-dessous seront disponibles via le lien envoyé par courriel une fois le processus complété.",
                    title: "Aperçu d'exportation",
                },
            },
            publish: {
                modal: {
                    description:
                        "Seules les factures déjà générées ou en cours de génération seront publiées. Une fois publiées, les factures seront accessibles par le compte d'administrateur de régime du client.",
                    title: "Aperçu de publication",
                    titles: {
                        client: "Client",
                        invoice: "Facture",
                        status: "Statut",
                    },
                    statuses: {
                        invoice:
                            "La facture <strong>{invoice}</strong> pour la période <strong>{period}</strong> de <strong>{client}</strong> ",
                        generated: "est prête à être publiée.",
                        generating: "est en cours de génération et elle sera publiée dès qu'elle sera prête.",
                        notGenerated: "n'a pas encore été générée.",
                        published: "a déjà été publiée.",
                        short: {
                            generated: "Générée",
                            generating: "En cours de génération",
                            notGenerated: "Non générée",
                            published: "Publiée",
                        },
                    },
                },
            },
            selectionTypes: {
                exclude: "Exclure les clients sélectionnés",
                include: "Exporter seulement les clients sélectionnés",
            },
        },
        exportAcomba: {
            form: {
                blocs: "Blocs",
                clients: "Clients (optionel)",
                intervalEnd: "Fin de l'intervalle",
                intervalStart: "Début de l'intervalle",
                exportType: "Mode",
            },
            messages: {
                error: "Une erreur s'est produite lors de l'exportation des factures :",
                errors: {
                    NO_ACOMBA_CUSTOMER_NUMBER: "Aucun code client Acomba.",
                    NO_ACOMBA_FEE_NUMBER: "Aucun code de coût Acomba.",
                    NO_ACOMBA_GST_NUMBER: "Aucun code TPS Acomba.",
                    NO_ACOMBA_HST_NUMBER: "Aucun code TVH Acomba.",
                    NO_ACOMBA_INSURER_NUMBER: "Aucun code d'assureur Acomba.",
                    NO_ACOMBA_PAYABLE_NUMBER: "Aucun code payable Acomba.",
                    NO_ACOMBA_PREMIUM_NUMBER: "Aucun code prime Acomba.",
                    NO_ACOMBA_QST_NUMBER: "Aucun code TVQ Acomba.",
                    NO_ACOMBA_RECEIVABLE_NUMBER: "Aucun code recevable Acomba.",
                    NO_BLOC_ERROR: "Aucune facture à exporter pour le bloc sélectionné.",
                    NO_CLIENT: "Aucun client de sélectionné.",
                    NO_INVOICE_ERROR: "Aucune factures à exporter pour la période sélectionée.",
                    NO_PROJECT_NUMBER: "Aucun numéro de projet Acomba.",
                    INVOICE_DATA_ERROR: "Erreur dans les données de facture.",
                    UNKNOWN_ERROR: "Erreur inconnue.",
                    INVOICE_DATA_TOTAL_ZERO: "Le total de la facture est de 0.",
                    NO_PROVINCE_ACOMBA_NUMBER: "Aucun code de province Acomba.",
                    NO_PROVINCE_FEDERAL_TAX_TYPE: "Aucun type de taxe fédérale.",
                    FTP_ERROR: "Une erreur est survenue lors de la connection au serveur FTP.",
                },
                success: {
                    generic: "L'exportation des factures a été complétée avec succès.",
                    errors: " en erreur.",
                    transferred: " {number, plural, one {exportée} other {exportées}}.",
                    linkText: "{number} {number, plural, one {facture} other {factures}}",
                    modal: {
                        errors: {
                            title: "Factures avec erreur d'exportation",
                        },
                        transferred: {
                            title: "Factures exportées",
                        },
                    },
                },
                warning: {
                    generic: "L'exportation des factures a été complétée, mais quelques erreurs sont survenues.",
                },
            },
        },
        exportInsurers: {
            form: {
                insurer: "Fournisseur",
                periodDate: "Période",
                languageCode: "Langue",
                fileFormat: "Format",
            },
        },
        exportMembers: {
            form: {
                client: "Client",
                billingPeriod: "Période de facturation",
                fileFormat: "Format",
                mustHaveMemberIdentifierRecoveryDate: "Seulement les participants ayant récupérés leur Code Major",
            },
        },
        exportReceivables: {
            form: {
                blocs: "Blocs",
                billingPeriod: "Période de facturation",
                message: "Aucune données disponibles pour ces paramètres sélectionnés",
            },
        },
        exportPayables: {
            form: {
                blocs: "Blocs",
                billingPeriod: "Période de facturation",
                message: "Aucune données disponibles pour ces paramètres sélectionnés",
            },
        },
        importMembers: {
            confirmation: {
                title: "Confirmation",
                message: "Veuillez confirmer l'information d'importation suivante :",
                fileName: "Nom du fichier",
                class: "Classe",
                classWarning:
                    "Attention, des couvertures déjà existantes peuvent être modifiées lors de votre import (notamment l’association PARTICIPANT-CLASSE). Merci de confirmer l’import selon les paramètres renseignés.",
            },
            form: {
                client: "Client",
                billingPeriod: "Période de facturation",
                class: "Classe",
                format: "Format",
                file: "Fichier",
                fileDesc: "Glissez le fichier à téléverser ici",
                importSessionPeriod: "Session à importer",
                warnings: {
                    noClientNumber:
                        "L’import de participants est actuellement impossible car le numéro de client n’est pas renseigné dans le profil du client, sous la rubrique ‘Informations générales'.",
                    noClasses:
                        "Le client sélectionné ne possède aucune classe de participants. Veuillez d'abord créer et configurer une classe de participants avant de poursuivre l'importation.",
                    noCoverages:
                        "Le client sélectionné ne possède aucun prix de couverture. Veuillez d'abord créer et configurer les prix de couvertures du client avant de poursuivre l'importation.",
                    noDivisions:
                        "Le client sélectionné ne possède aucune division. Veuillez d'abord créer et configurer une division avant de poursuivre l'importation.",
                    automaticMemberIdentifier: "Des numéros uniques automatiques seraient créés pour ce client",
                    clientInTransition:
                        "Attention, des actions techniques liées à la planification d’inactivité du client sont en cours. Vos modifications peuvent être perturbées par ce processus technique. Nous vous recommandons de patienter quelques minutes.",
                },
            },
            messages: {
                success: "L'importation a été complétée avec succès.",
                warning:
                    "L'import s'est réalisé mais une erreur non bloquante est survenue.",
                error: "Une erreur s'est produite lors de l'importation :",
                received: "{received, number} {numberOfReceived, plural, one {membre reçu} other {membres reçus}}",
                updated: "{updated, number} {numberOfUpdated, plural, one {membre} other {membres}} mis à jour",
                imported:
                    "{imported, number} {numberOfImported, plural, one {membre importé} other {membres importés}}",
                transferred:
                    "{transferred, number} {numberOfTransferred, plural, one {membre transféré} other {membres transférés}} vers la nouvelle période de facturation",
                renewed:
                    "{renewed, number} {numberOfRenewed, plural, one {membre renouvelé} other {membres renouvelés}} sur la nouvelle période de facturation",
                successDetails: "{received, number} participants importés.",
                existingMembers: "À noter que {numberExistingMembers, plural, one {le participant suivant était} other {les participants suivants étaient}} en double dans la liste à importer ou déjà {numberExistingMembers, plural, one {couvert} other {couverts}} : {existingMembers}",
                droppedOutWarning: "Pour les certificats suivants, l'import n'est pas possible car leur précédent statut est 'Abandon de cours'. Veuillez les mettre à jour manuellement :{br}{nonImportedMembersList}",
            },
            errors: {
                message: "Pour le participant N° {member_identifier}, erreur pour la donnée '{key}': ",
                expected: "{numberOfValues, plural, one {Valeur attendue} other {Valeurs attendues}}",
                value: "Valeur actuelle",
                lastActiveDateError:
                    "La date de début ou la date de fin de la couverture pour un ou plusieurs participant(s) est soit vide, soit postérieure au dernier jour d'activité du client : {lastActiveDate}. Veuillez vérifier les informations et réessayer",
                code: {
                    ValueError: "Erreur de donnée",
                    NotFoundError: "Non trouvée",
                    ValueRegexError: "Non conforme",
                    DuplicateError: "Dupliquée",
                    MaxLengthError: "Longueur maximale dépassée ({expected} max.)",
                    UnauthorizedCountryCode: "Non conforme"
                },
                key: {
                    birthdate: "Date de naissance",
                    coverageCode: "Code de couverture",
                    firstName: "Prénom",
                    lastName: "Nom de famille",
                    memberIdentifier: "Identifiant du membre",
                    memberGenderType: "Sexe",
                    schoolIdentifier: "Identifiant de l'université",
                    isInternational: "International",
                    quarter: "Période",
                    invoicedAmount: "Montant facturé",
                    address: "Adresse postale",
                    city: "Ville",
                    postalCode: "Code postal",
                    phoneNumber: "Numéro de téléphone",
                    emailAddress: "Courriel",
                    personalIdentifier: "Identifiant personnel",
                },
            },
        },
        agecro: {
            sessionTypes: {
                winter: "Hiver",
                summer: "Été",
                fall: "Automne",
            },
            memberInformationsTable: {
                birthdate: "Date de naissance",
                coverageCode: "Code de couverture",
                firstName: "Prénom",
                lastName: "Nom",
                memberIdentifier: "Identifiant du membre",
                invoicedAmount: "Montant facturé",
                statusFees: "Statut des frais",
                session: "Session"
            },
            errors: {
                fetchingStudents: "Impossible de récupérer la liste des étudiants depuis l’API Rosemont. Il est possible que la connexion à l'API ne soit pas opérationnelle ou que la période de facturation sélectionnée ne renvoie aucune information."
            }
        },
        formats: {
            agecar: "Modèle universitaire, désistement Major (AGECAR)",
            agectr: "Modèle CEGEP, désistement Major (AGECTR)",
            ageuqtr: "Modèle universitaire, désistement in-house (AGEUQTR)",
            aelcc: "Format AELCC",
            aeteluq: "AETELUQ (import via API)",
            agecro: {
                continuingEducation: "AGECRo - Formation continue (import via API)",
                regularEducation: "AGECRo - Formation régulière (import via API)",
                onlineEducation: "AGECRo - Formation à distance (import via API)"
            },
            mondial: "Modèle Liste voyage",
            withdrawal: "Liste des participants désistés",
            symbility: "Modèle Symbility",
            corporate: "Modèle corporatif",
            eligibility_report_1: "Rapport de certificat 1",
            akira: "Modèle Télémédecine",
            eligibility_report_2: "Rapport de certificat 2",
            ftp: "Envoyer par FTP",
            manual: "Manuel",
            premiums: "Modèle Primes",
            feus: "Modèle FEUS",
        },
        exports: {
            form: {
                exportationType: "Type d'exportation",
            },
        },
        exporting: "Exportation en cours",
        importing: "Importation en cours",
        pages: {
            importMembers: "Importation",
            exports: "Exportation",
            accountingExports: "Comptabilité",
            exportAcomba: "Exportation acomba",
            exportManyInvoices: "Exportation/publication de factures",
            exportInsurers: "Export fournisseur",
            reports: "Rapports disponibles",
        },
        exportTypes: {
            receivables: "Recevables",
            payables: "Payables",
            client: "Client",
            insurers: "Fournisseur",
            acomba: "Acomba",
            corporate: "Publication des factures de clients corporatifs",
        },
    },
    invoices: {
        title: "Factures",
        datatable: {
            informations: {
                beginingNextPeriod: "Début de la prochaine période de révision : ",
                finalInvoiceGeneration: " Génération des factures définitives STANDARD : ",
                finalInvoiceGenerationDelayed: " Génération des factures définitives DÉCALÉES : ",
                standardInvoiceType: "STANDARD",
                creditsInvoiceType: "AJUSTEMENTS",
                templateInvoiceType: "GABARIT",
                terminationInvoiceType: "TERMINAISON",
            },
            actions: {
                warning: " ATTENTION ",
                unauthorizedDelayAction: "Votre rôle n'a pas les droits de décaler les périodes de facturation.",
                warningMessage:
                    "Des changements ont été faits dans les paramétrages du client. Pensez a réviser la facture pour visualiser les impacts de ces changements.",
                normalMessage:
                    "Aucun changement de données n'a été réalisé. La version présentement accessible retranscrit la version la plus actuelle des données du client.",
                add: "Générer une facture",
                cancel: "Annuler la facture",
                view: "Visionner la facture",
                editBillingAddress: "Options de facturation",
                invoiceOffset: "Décalage de la facture : {bpName}",
                templateInvoice: "Générer une facture gabarit",
                templateError: "Une erreur est survenue lors de la génération de la facture gabarit",
                templateMissingClientInfo:
                    "La facture au format GABARIT se génère pour un montant de 0$, veuillez vérifier le paramétrage des garanties de votre client.",
                templateMissingBillingPeriod: "Le client MEV n'a pas de période de facturation pour le mois prochain.",
                templateGenerationSuccess: "La facture au format GABARIT a été générée avec succès",
                templateGenerationFailure: "La facture au format GABARIT n'a pas pu être générée. Veuillez réessayer",
                reviewGenerationSuccess: "La facture a été révisée avec succès",
                reviewGenerationFailure: "La facture n'a pas pu être révisée. Veuillez réessayer",
                modalInvoiceDelayedWarning:
                    "Attention, si vous activez le décalage de la période de facturation {bpName}, la facture du client sera générée lors de l'étape décalée du mois portant sa génération. Cette action est irréversible, aucun retour en arrière ne sera possible. Êtes-vous sûr de vouloir décaler la génération de cette facture ?",
                noBillingPeriods:
                    "Aucune période de facturation n'est configurée pour le client. Vous devez définir au moins une période de facturation avant de pouvoir générer une facture.",
            },
            columns: {
                amount: "Montant",
                billingPeriod: "Période de facturation",
                endDate: "Date de fin",
                invoiceNumber: "Numéro de facture",
                startDate: "Date de début",
                status: "État de la facture",
                summaryOnly: "Sommaire uniquement",
                summaryAndListOfParticipants: "Sommaire et liste des{br}participants",
                summaryCostsAndCoverages: "Sommaire des couts et{br}couvertures",
                invoiceType: "Type de facture",
            },
        },
        form: {
            billingPeriodModal: {
                title: "Période de facturation",
            },
            addressSettings: {
                title: "Adresse de facturation",
            },
            otherSettings: {
                title: "Autres options",
            },
            recipient: "Destinataire",
            address: "Adresse",
            city: "Ville",
            country: "Pays",
            province: "Province",
            postalCode: "Code postal",
            phoneNumber1: "Téléphone 1",
            phoneNumber2: "Téléphone 2",
            fax: "Télécopieur",
            emailAddress: "Courriel",
            website: "Site web",
            showPaymentNotice: "Afficher la notice de paiement",
            ungroupGuaranteesInInvoices: "Dégrouper les garanties sur les factures",
            includeWithdrawalMembers:
                "Inclure sur la facture les participants ayant un statut <span class='emphasis'>Inactif - Désisté</span>",
        },
        cancelButton: {
            title: "Annulation de facture",
            standardMessage: "Êtes-vous certain de vouloir annuler la facture {invoiceName}",
            warningMessage:
                "<p>Annuler une facture dans le passé aura un impact sur les calculs des factures futures.</p>" +
                "<p>Êtes-vous certain de vouloir annuler la facture {invoiceName}?</p>",
        },
        resetButton: {
            title: "Réinitialisation de facture",
            message: "Êtes-vous certain de vouloir réinitialiser le statut de la facture {invoiceNumber}?",
        },
        status: {
            exportedToAcomba: "Exportée",
            failure: "Échec",
            generated: "Générée",
            generating: "En cours de génération",
            notGenerated: "Non générée",
            review: "Révision",
            template: "Gabarit",
            published: "Publiée",
        },
        view: {
            title: "Visualiser la facture",
            form: {
                fileType: "Format",
                insurerId: "Fournisseur",
            },
            types: {
                PDF: "PDF",
                EXCEL: "EXCEL",
                longPDF: "Sommaire et liste des participants (PDF)",
                shortPDF: "Sommaire uniquement (PDF)",
                longExcel: "Sommaire et liste des participants (Excel)",
                shortExcel: "Sommaire uniquement (Excel)",
                shortInsurerExcel: "Sommaire des assureurs uniquement (Excel)",
                summaryExcel: "Sommaire des coûts et couvertures (Excel)",
                premiumByInsurer: "Rapport de prime par assureur",
            },
            invoiceTypes: {
                credits: "Ajustements",
            },
        },
    },
    locale: {
        "en-CA": "Anglais",
        "fr-CA": "Français",
    },
    login: {
        title: "Major System",
        button: "Connexion",
        timeout: {
            title: "Expiration de la session",
            body:
                "Vous avez été inactif et votre session a expiré. Veuillez fermer ce message pour ouvrir une nouvelle session.",
        },
        errors: {
            Unauthorized: "Vous avez fourni des informations d'identification erronées.",
            login_failed_locked:
                "Vous êtes bloqué de l'application en raison de plusieurs échecs de la connexion.<br />Veuillez utiliser la procédure de mot de passe oublié pour débloquer votre compte.",
            login_failed:
                "Vous avez fourni des informations d'identification erronées.<br />Vous serez bloqué de l'application si vous échouez encore {triesLeft} {triesLeft, plural, one {autre} other {autres}} fois.",
            connection_timeout: "Session expirée, veuillez vous reconnecter",
        },
        associatedClientsLoadError: "Erreur lors du chargement de vos clients. Veuillez actualiser la page.",
        environments: {
            local: "Environnement local",
            qa: "Environnement de QA",
            qa2: "Environnement de QA2",
            staging: "Environnement de Staging",
            demo: "Environnement de Démo",
        },
    },
    resetPassword: {
        title: "Major System",
        passwordExpired: "Votre mot de passe a expiré.",
        username: "Identifiant",
        emailAddress: "Courriel",
        resetInstructions:
            "Saisissez l'identifiant et l'adresse courriel associés à votre compte pour réinitialiser votre mot de passe.",
        emailSent:
            "Si un compte existe avec l'information fournie, nous vous enverrons un courriel avec des instructions pour réinitialiser votre mot de passe.",
        password: "Mot de passe",
        confirmPassword: "Confirmation",
        submit: "Soumettre",
        resend: "Ré-envoyer le courriel",
        change: "Changer",
        goToLogin: "Retour à la page de connexion",
        resetProcessed: "Si vos informations sont valides, vous receverai un courriel sous peu",
        resetFailed: "Le mot de passe n'a pas pu être réinitialisé, veuillez réessayer",
        invalidToken:
            "Votre lien de connexion est expiré, une relance vous a été envoyée par notification courriel.<br />Si vous rencontrez des difficultés de connexion, merci de contacter votre gestionnaire de compte.",
        resetSucceeded: "Mot de passe réinitialisé",
        newPasswordInstructions: "Veuillez saisir un nouveau mot de passe.",
        userFullName: "{userFullName},",
        passwordChanged: "Votre mot de passe a été correctement enregistré.",
        loginCredentials: "Vous pouvez vous connecter avec ce dernier et votre identifiant directement via ",
        followingLink: "le lien suivant",
        errors: {
            passwordsMatch: "Les mots de passe ne correspondent pas",
            passwordRequirements: "Le nouveau mot de passe ne répond pas aux exigences de sécurité",
            invalidToken:
                "Votre lien de connexion est expiré, une relance vous a été envoyée par notification courriel.<br />Si vous rencontrez des difficultés de connexion, merci de contacter votre gestionnaire de compte.",
            samePasswordError: "Le nouveau mot de passe ne peut pas être identique à l'ancien",
            resetPasswordFailed: "Une erreur est survenue lors de l'opération",
            "Server Error": "Une erreur est survenue lors de l'opération",
            ssoPasswordResetError: "Vous ne pouvez pas réutiliser un mot de passe déjà configuré précédemment",
        },
    },
    memberCoverages: {
        title: "Couverture",
        errors: {
            modalTitles: {
                generic: "Erreur",
                missing_required_fields: "Profil incomplet",
                overlapping_coverage: "Conflit de dates",
            },
            messages: {
                fields: {
                    address: "Adresse",
                    birthdate: "Date de naissance",
                    city: "Ville",
                    countryCode: "Pays",
                    firstName: "Prénom",
                    employment: "Emploi",
                    lastName: "Nom de famille",
                    memberGenderType: "Sexe",
                    postalCode: "Code postal",
                    provinceCode: "Province",
                },
                generic: "Une erreur est survenue.",
                missing_required_fields:
                    "La couverture ne peut être modifiée ou ajoutée car de l'information est manquante. " +
                    "Veuillez s'il vous plaît compléter les champs suivants dans le profil du participant:",
                end_date_required_for_inactivation_error:
                    "La date de fin est obligatoire pour un client inactif, terminé ou encore avec un plan d'inactivation.",
                overlapping_coverage: "Les dates fournies entrent en conflit avec d'autres couvertures.",
                modifyMemberCoverageInactivationError:
                    "Vous ne pouvez pas modifier une couverture dont la date de début est supérieure à la date d'inactivation du client.",
                newMemberCoverageInactivationError:
                    "Vous ne pouvez pas créer une couverture dont la date de début est supérieure à la date d'inactivation du client.",
                clientStatusTypeError: "Vous ne pouvez pas créer une couverture de membre pour un client INACTIF.",
                "Bad Request": "Une erreur est survenue. Veuillez vérifier les informations fournies.",
            },
        },
        datatable: {
            actions: {
                add: "Ajouter une couverture",
                edit: "Modifier la couverture",
                view: "Visionner la couverture",
            },
            toolTips: {
                syncToolTipWarning: "La couverture n'est pas synchronisée.",
                syncToolTipWarningWithError: "Une ou plusieurs erreurs de synchronisation se sont produites : {error}",
                syncToolTip: "La couverture est synchronisée.",
                syncToolTipStarted: "La couverture est en cours de synchronisation.",
                relatedCoverageToolTipWarning: "Une couverture d'une session précédente a été synchronisée plus récemment que celle-ci. Les dates de couvertures présentes dans Telus Adjudicare peuvent ne pas être à jour."
            },
            addTypes: {
                class: "Changement de classe",
                division: "Changement de division",
                new: "Nouvelle couverture",
                other: "Autre changement",
                salary: "Changement de salaire",
                status: "Changement de statut",
                type: "Changement de type",
            },
            columns: {
                date: "Date",
                period: "Période de couverture",
                periodFrom: "À partir du ",
                today: "aujourd'hui",
                type: "Type",
                class: "Classe",
                status: "Statut",
                occupation: "Occupation",
                salary: "Salaire",
                sync: "Sync.",
            },
        },
        form: {
            arePremiumsWaived: "Exonération de primes",
            billingPeriod: "Période de facturation",
            startDate: "Date de début",
            defineEndDate: "Définir une date de fin",
            endDate: "Date de fin",
            status: "Statut",
            inactivityReason: "Raison de l'inactivité",
            inactivityReasonDate: "Date du désistement",
            inactivityReasonDetails: "Spécifiez",
            coverageType: "Type",
            paid: "Payé",
            paidToBroker: "Prime payée directement à Major",
            type: "Type",
            class: "Classe",
            division: "Division",
            occupation: "Occupation",
            salary: "Salaire",
            guarantees: "Garanties",
            noGuarantees: "Cette classe n'a pas encore de garanties associées...",
            noSelection: "Veuillez sélectionner une classe pour afficher les garanties associées.",
            ageOfPolicyExpiration: "Âge limite",
            ageOfPolicyDecrease: "âge de diminution",
            volume: "Volume",
            warningRetroModification: "Vous ne pouvez pas appliquer de modification de couverture.",
            warningDateForRecurring: "La couverture ne peut être créée ou mise à jour qu'à partir de {date}",

            allowance: {
                MONTH: "Taux client mensuel",
                BILLING_PERIOD: "Taux client",
            },
            supplierRate: {
                MONTH: "Taux fournisseur mensuel",
                BILLING_PERIOD: "Taux fournisseur",
            },
            removeFromList: "Retiré des listes de l'association étudiante",
            mustNotInvoice: "Ne pas ajouter à la facture",
            formulaMspa: "Volume différent",
        },
        modal: {
            dependent: {
                singleTitle: "Avertissement – Garantie retirée automatiquement",
                singleMessage: "La garantie {guaranteeName} a été automatiquement décochée, car les conditions requises ne sont plus réunies (aucune garantie pilotant les garanties obligatoires de personnes à charge active avec une couverture autre que individuelle).\n\nVeuillez vérifier la couverture de ce participant avant de confirmer.",
                multipleTitle: "Avertissement – Garanties retirées automatiquement",
                multipleMessageIntro: "Les garanties suivantes ont été automatiquement décochées, car les conditions requises ne sont plus réunies (aucune garantie pilotant les garanties obligatoires de personnes à charge active avec une couverture autre que individuelle) :",
                multipleMessageOutro: "Veuillez vérifier la couverture de ce participant avant de confirmer.",
                confirmButton: "Valider",
            },
        },
        nav: {
            all: "Toutes les p.à.c.",
            coverages: "Couvertures",
        },
        inactivityReasons: {
            notPaid: "Non-payé",
            other: "Autre : {comment}",
            withdrawnPermanently: "Désisté permanent : {date}",
            withdrawnPermanentlyNotPaid: "Désisté permanent, Non-payé : {date}",
            withdrawnYearly: "Désisté annuel : {date}",
            withdrawnYearlyNotPaid: "Désisté annuel, Non-payé : {date}",
            droppedOut: "Abandon de cours : {date}",
            otherClean: "Autre",
            withdrawnPermanentlyClean: "Désisté permanent",
            withdrawnPermanentlynotPaidClean: "Désisté permanent, Non-payé",
            withdrawnYearlyClean: "Désisté annuel",
            withdrawnSessionallyClean: "Désisté par session",
            withdrawnYearlynotPaidClean: "Désisté annuel, Non-payé",
            droppedOutClean: "Abandon de cours",
            deathClean: "Décès",
            boughtByClientOutsideMajorClean: "Acheté par autre client hors Major",
            boughtByMajorClientClean: "Acheté par autre client Major",
            leavingForCompetitorClean: "Va chez compétiteur",
            noLongerOffersGroupInsuranceClean: "N'offre plus de collectif (trop cher)",
            eligibilityCriteriaTooSmallClean: "Critères d'éligibilité (groupe trop petit)",
            bankruptcyClean: "Faillite",
        },
        types: {
            family: "Familial",
            couple: "Couple",
            single: "Individuel",
            singleParent: "Monoparental",
            waived: "Renoncé",
            multiple: "Multiple",
            other: "Autre"
        },
        validation: {
            endDateMustBeLowerThanNextCoverageStartDate:
                "La date de fin doit être avant la date de début de la prochaine couverture",
            startDateMustBeLowerThanNextCoverageStartDate:
                "La date de début doit être avant la date de début de la prochaine couverture",
            startDateMustBeHigherThanPreviousCoverageStartDate:
                "La date de début doit être après la date de début de la couverture précédente",
            guaranteeSelection: "Vous devez sélectionner au moins une garantie",
            occupationRequired: "Veuillez indiquer l'occupation ou le métier du participant",
        },
    },
    beneficiaries: {
        title: "Bénéficiaires",
        form: {
            title: "Ajouter un bénéficiaire",
            lastName: "Nom de famille",
            firstName: "Prénom",
            percentageSplit: "Part en %",
            birthdate: "Date de naissance",
            relationship: "Lien avec le participant",
            revocable: "Révocable",
            irrevocable: "Irrévocable",
            fiduciaryLastName: "Nom du fiduciaire",
            fiduciaryFirstName: "Prénom du fiduciaire",
            fiduciaryBirthdate: "Date de naissance du fiduciaire",
            fiduciaryRelationship: "Relation du fiduciaire",
            isMinor: "Ce bénéficiaire est mineur",
        },
        datatable: {
            columns: {
                name: "Nom",
                relationship: "Relation",
                percentageSplit: "Part en pourcentage",
                birthdate: "Date de naissance",
                actions: "Actions",
                isRevocable: "Révocable",
                isMinor: "Mineur",
            },
            actions: {
                edit: "Modifier le bénéficiaire",
                includeArchivedBeneficiaries: "Inclure les bénéficiaires archivés",
                add: "Ajouter un bénéficiaier",
                view: "Visionner le bénéficiaire",
            },
        },
    },
    employments: {
        title: "Emplois",
        form: {
            title: "Ajouter un emploi",
            employmentType: "Type",
            startDate: "Date de début",
            endDate: "Date de fin",
            defineEndDate: "Définir une date de fin",
            info: {
                employmentFutureDate: "Tous les nouveaux enregistrements d’emploi doivent être ajoutés avec des dates de début postérieures aux entrées existantes. Si vous devez insérer un enregistrement avec une date antérieure, commencez par ajuster les enregistrements existants en conséquence, puis ajoutez la nouvelle entrée."
            },
        },
        datatable: {
            columns: {
                employmentType: "Type",
                date: "Date",
                periodFrom: "À partir du ",
            },
            actions: {
                edit: "Modifier l'emploi",
                add: "Ajouter un emploi",
                view: "Visionner l'emploi",
            },
            errors: {
                overlappingMemberEmploymentError: "Les dates d'emploi que vous avez saisies chevauchent une ou plusieurs périodes d'emploi existantes pour ce participant. Veuillez vérifier les périodes existantes et ajuster les dates en conséquence.",
                earlierMemberEmploymentError: "Il n’est pas autorisé de créer une nouvelle période d’emploi pour un participant avec une date de début antérieure aux périodes existantes. Veuillez mettre à jour les périodes d'emploi actuelles en conséquence avant de continuer.",
            }
        },
        employmentTypes: {
            employment: "Emploi",
        },
    },
    members: {
        title: "Participants",
        selectionsOfMembersForCoverageConfirmation:
            "Participants sélectionnés pour la génération de confirmation de couverture",
        noMembersSelected: "Aucun participant sélectionné",
        memberNotSynced: "Ce participant n'est pas synchronisé.",
        nonMemberSync: "Ce participant n'est pas synchronisable.",
        disableSync: "Désactivation de la synchronisation",
        notTransmittedWarning: 'Les participants ayant le nom "non transmis" ne peuvent pas être synchronisés',
        onlyCanadianSyncWarning: "Les participants avec un pays autre que Canada ne peuvent pas être synchronisés",
        completeButNotActivatedWarning: "Ce participant n'a pas d'accès au portail participant. Afin de lui envoyer automatiquement ses documents, changez le statut de sa couverture active pour la rendre inactive, sauvegardez la modification, puis activez la de nouveau.",
        activateDisableSyncWarning: "Si vous désactivez la synchronisation automatique du participant, ses données de profil, de couvertures et de personnes à charge ne seront plus synchronisées."
            + " Les données déjà synchronisées ne seront pas modifiées.{br}{br}Êtes-vous sûr de vouloir continuer ?",
        deactivateDisableSyncWarning: "Si vous activez la synchronisation automatique du participant, ses données de profil, de couverture et de personnes à charge seront synchronisées. "
            + "Si le participant a déjà des données synchronisées, elles seront écrasées avec les nouvelles données.{br}{br}Êtes-vous sûr(e) de vouloir continuer ?",
        datatable: {
            actions: {
                add: "Ajouter un participant",
                edit: "Modifier le participant",
                view: "Visionner le participant",
                includeArchivedMembers: "Inclure les participants archivés",
                newMembers: "Nouveaux participants",
                includeInactiveMembers: "Inclure les participants inactifs",
                coverageConfirmations: "Générer les confirmations de couverture",
                numberOfMembersSelectedForPeriod:
                    "Participants sélectionnés pour la période: {period} ({membersCount})",
            },
            columns: {
                member: "Participant",
                memberIdentifier: "Numéro unique",
                division: "Division",
                age: "Âge",
                status: "Statut",
                sync: "Sync.",
                activationStatus: "Activation"
            },
            toolTips: {
                memberNoSync: "Le participant n'est pas synchronisable.<br/><br/>1- Il ne doit pas être associé à un client ayant l'un des statuts suivants: Mise en vigueur, Terminé.<br/><br/>2- Il ne doit pas être archivé.<br/><br/>3- Sa synchronisation doit être activée.<br/><br/>4- Il doit avoir une adresse canadienne.<br/><br/>5- Il doit avoir au moins une couverture<br/><br/>6- Il ne doit pas avoir le nom non transmis.",
                syncToolTipWarning: "Le participant n'est pas synchronisé.",
                syncToolTipWarningWithError: "Une ou plusieurs erreurs de synchronisation se sont produites : {error}",
                syncToolTip: "Le participant est synchronisée.",
                syncToolTipStarted: "La synchronisation du participant est en cours."
            }
        },
        payFrequencies: {
            monthly: "Mensuelle",
            biweekly: "Bimensuelle",
            weekly: "Semaine",
        },
        form: {
            formChangeWarning: "Attention, vos changements dans la page des participants n'ont pas été sauvegardés, veuillez utiliser le bouton de sauvegarde du formulaire.",
            invalidUniqueNumberAlphabet: "Le numéro unique est invalide. Seuls les caractères numériques sont acceptés (0-9).",
            memberIdentifier: "Numéro unique",
            memberIdentifierRecoveryDate: "Date de récupération du Code Major",
            firstName: "Prénom",
            lastName: "Nom de famille",
            phoneNumber: "Numéro de téléphone",
            extensionNumber: "Numéro de poste",
            emailAddress: "Courriel",
            birthdate: "Date de naissance",
            socialInsuranceNumber: "NAS",
            memberGenderType: "Sexe",
            languageCode: "Langue",
            isSmoker: "Fumeur",
            isCanadian: "Canadien(ne) ou Résident(e) permanent(e)",
            provincialHealthNumber: "Numéro de carte d’assurance maladie provinciale",
            importationDate: "Date d'importation",
            address: "Adresse",
            city: "Ville",
            occupation: "Fonction",
            provinceCode: "Province",
            postalCode: "Code postal",
            country: "Pays",
            weeklyHours: "Heures travail / semaine",
            memberPayFrequencyType: "Fréquence paie",
            employeeNumber: "Numéro d'employé",
            isInternational: "International",
            status: "Statut",
            persoInfo: "Information personnelle",
            postalAddress: "Adresse postale",
            clientInfo: "Information client corporatif",
            customEmailAddress: "Courriel",
            customPhoneNumber: "Téléphone",
            customInformation: "Note",
            division: "Division",
            confirmationMessage: "Les changements apportés à ce formulaire sont automatiquement sauvegardés.",
            confirmationTitle: "Attention !",
            schoolIdentifier: "Numéro de l’université",
            personalIdentifier: "Code d'identification",
            quarter: "Quarter",
            error: {
                healthCardInfo:
                    "Le numéro de carte de santé provinciale est obligatoire pour les membres non canadiens ; s'il n'est pas disponible, sélectionnez 'N/D' dans l'option Canadien(ne) ou Résident(e) permanent(e).",
                noClientNumber:
                    "La création d'un participant est actuellement impossible car le numéro de client n'est pas renseigné dans le profil du client, sous la rubrique 'Informations générales'.",
                phoneNumberError: "Le numéro de téléphone doit respecter le format suivant: (XXX) XXX-XXXX.",

            },
        },
        followUps: {
            activities: "Activités",
            addNote: "Ajouter une note",
            editNote: "Modifier une note",
            form: {
                fileDepositWarning:
                    "Vous disposez de 5 minutes pour faire le dépôt de fichier. En cas d’erreur, vous pouvez enregistrer votre suivi et le ré-ouvrir pour déposer vos fichiers.",
                action: "Action",
                date: "Date",
                user: "Utilisateur",
                priority: "Priorité",
                deadline: "Date d'échéance",
                type: "Type",
                origin: "Origine",
                subType: "Sous type",
                associatedLinks: "Lien(s) associé(s)",
                category: "Catégorie",
                generateFollowUp: "Générer un suivi",
                description: "Description",
                transactionAmount: "Montant de la transaction (si applicable)",
                followUpInformation: "Information de suivi",
                memberName: "Nom du participant",
                memberIdentifier: "Numéro unique",
                clientName: "Client",
                preferredContact: "Coordonnées de préférence du participant",
                phone: "Téléphone",
                email: "Courriel",
                profileContact: "Coordonnées fournies par le client",
                followUpRecipient: "Envoyer le suivi à",
                followUpClosedOn: "Date de fermeture",
                followUpClosedBy: "Fermé par",
                closeFollowUp: "Fermer le suivi",
                closedFollowUp: "Suivi fermé",
                closeFollowUpReason: "Raison de la fermeture",
                comments: {
                    commentLabel: "Ajouter un commentaire",
                    commentListEmpty: "Aucun commentaire",
                    commentSubmit: "Envoyer",
                    edit: "Modifier un commentaire",
                    systemComment: "Message du système",
                },
                emails: {
                    resend: "Renvoyer le courriel",
                    sendEmailTitle: "Renvoi du courriel d’activation de compte",
                    sendEmailMessage:
                        "Un courriel va à nouveau être envoyé à l’utilisateur {userFullName} avec ses informations de connexion à l’adresse courriel {email}. Êtes vous sûr de confirmer cette action ?",
                    success: {
                        resultTitle: "Renvoi du courriel d’activation de compte avec succès",
                        resultMessage:
                            "Le courriel d’activation de compte de l’utilisateur {userFullName} a été renvoyé avec succès à l’adresse {email}. Le suivi lié a été mis à jour.",
                    },
                    failure: {
                        resultTitle: "Attention, échec du renvoi du courriel",
                        resultMessage:
                            "La notification courriel avec les informations de connexion de l'utilisateur n'a pas pu renvoyé à l'adresse {email}, veuillez vérifier les informations de l'adresse courriel.",
                    },
                },
                errors: {
                    invalidData: "Les données saisies ne correspondent pas aux critères.",
                },
            },
            types: {
                note: "Note",
                incidentFollowUp: "Suivi d'incident",
                specialModification: "Modification spéciale",
                passwordManagement: "Gestion de mot de passe",
                systemNote: "Note du système",
            },
            statusTypes: {
                closed: "Fermé",
                open: "En attente",
                new: "Nouveau",
            },
            incidentFollowUpCategories: {
                csQuality: "Qualité du service à la clientèle",
                claims: "Réclamations",
                withdrawal: "Désistement",
                planModification: "Modification au régime",
                shiBD: "SHi/Base de données",
                other: "Autre",
            },
            specialModificationCategories: {
                reintegration: "Réintegration",
                withdrawal: "Désistement",
                memberAddition: "Ajout d'un participant",
                dependentAddition: "Ajout d'une personne à charge",
                checkRefund: "Remboursement par chèque",
                bankTransferRefund: "Remboursement par virement",
                checkCancellation: "Annulation de chèque",
                transferCancellation: "Annulation de virement",
                other: "Autre",
            },
            origin: {
                manual: "Manuelle",
                note: "Note",
                email: "Courriel",
                phone: "Téléphone",
                system: "Système",
            },
            priorities: {
                urgent: "Urgent",
                twoDays: "48h",
                medium: "Moyen",
            },
        },
        member: {
            actions: {
                edit: "Modifier les informations de contact",
                confirmation: "Générer une confirmation de couverture",
                blockFromWithdrawal: "Désistement bloqué",
                majorCard: "Générer la carte Major",
                sendMajorCard: "Générer et envoyer la carte Major",
                description: "Générer la carte Major",
                selectAll: "Sélectionner tout",
                generating: "Génération en cours des cartes Major",
                error: "Une erreur s'est produite lors de l'importation des cartes",
            },
            errors: {
                noTravelHealthFoundForClient: "Le client n'a pas d'assurance voyage ou maladie",
                noHealthOrTravelGuaranteeFoundForMember: "Le membre {identifier} n'a pas d'assurance voyage ou maladie",
                NoCoverageFound: "Le membre {identifier} n'a aucune couverture",
                invalidDataType: "La nouvelle valeur n'est pas au bon format",
                majorCardInactiveOrInvalidSyncError: "Le client n'est pas admissible à la génération de carte Major. Veuillez actualiser la page et vérifier que le statut du client n'est pas « Inactif » et confirmer que le client possède un type de synchronisation valide."
            },
            pages: {
                profile: "Profil",
                insurance: "Couverture",
                dependents: "Personnes à charge {count, plural, =0 {} other {({count})}}",
                beneficiaries: "Bénéficiaires {count, plural, =0 {} other {({count})}}",
                employments: "Emplois"
            },
        },
        error: {
            coverageConfirmations: {
                genericError:
                    "Une erreur est survenue lors de la génération des confirmations de couverture. Veuillez contacter le support.",
                noMemberFound:
                    "Aucun participant éligible à l'export n'a été trouvé avec les informations fournies. Veuillez valider vos filtres.",
            },
        },
        warning: {
            coverageConfirmations: {
                genericWarning:
                    "La génération des confirmations de couverture est terminée mais certains participants sont en erreur. Plus de détails dans le fichier TXT généré et disponible dans le ZIP téléchargé.",
            },
        },
    },
    memberIdentifierConfiguration: {
        form: {
            createRecoveryForm: "Créer un <strong>formulaire de récupération du Code Major</strong>",
            mustUseInstitutionEmailForRecovery: "Forcer l'utilisation du courriel institutionnel",
            recoveryFormMessage: "Message d'introduction du formulaire",
        },
    },
    memberIdentifierRecovery: {
        body: {
            title: "Récupération du Code Major",
        },
        form: {
            title: "Formulaire de récupération à remplir",
            lastName: "Nom",
            firstName: "Prénom",
            postalCode: "Code postal",
            birthdate: "Date de naissance",
            phoneNumber: "Numéro de téléphone",
            institutionEmail: "Courriel institutionel",
            memberEmail: "Courriel",
            conditions: {
                byRecovering: "En récupérant mon Code Major :",
                condition1:
                    "Je comprends que le Code Major est un code unique qui sert à m’identifier auprès de Plan Major lors de chacune de mes réclamations et communications, et ce, pendant toute la durée de mes études dans mon institution actuelle.",
                condition2: "Les renseignements fournis dans ce formulaire sont complets et véridiques.",
                condition3:
                    "En soumettant ce formulaire, je consens à ce que les informations saisies soient transmises et utilisées par Plan Major dans le cadre de la gestion du régime d’assurance collective ou des services connexes. Ces renseignements pourraient notamment être transmis aux assureurs, fournisseurs-tiers ou mon association étudiante afin de permettre le bon fonctionnement du service.",
                condition4:
                    "Je confirme qu’il s’agit bien de mon identité, et je comprends que si je fais la demande pour une autre personne, cela pourrait être considéré comme étant de l’usurpation d’identité avec les conséquences qui peuvent s’y rattacher.",
            },
            submit: "Soumettre",
        },
        messages: {
            errors: {
                fieldMissing:
                    "Un ou plusieurs champs sont manquants. Veuillez vérifier les données entrées dans le formulaire.",
                recoveryFormNotAvailable:
                    "Le formulaire de récupération du Code Major n'est pas disponible pour l'instant.",
                memberNotFound:
                    "Nous n'avons pas été en mesure de récupérer votre Code Major à l'aide de l'information que vous avez fourni. Veuillez vérifier l'information entrée ou contacter le Plan Major au 1-877-976-2567 ou à etudiant@planmajor.ca.",
                multipleMembersFound:
                    "Plus d'un Code Major a été trouvé à l'aide des informations que vous avez fourni. Veuillez contacter le Plan Major au 1-877-976-2567 ou à etudiant@planmajor.ca.",
                "Server Error":
                    "Une erreur est survenue lors de l'opération. Veuillez réessayer plus tard. Si le problème persiste, contactez un responsable de votre association.",
                recaptchaFailed: "La vérification reCaptcha n'a pas fonctionnée.",
                invalidBirthdate: "Vous devez entrer une date de naissance valide.",
            },
            success:
                "Votre demande de récupération du Code Major a été complétée avec succès! Votre Code Major est : {memberIdentifier}",
            successModalTitle: "Récupération du Code Major complétée",
            successModalBody:
                "<h4>Votre Code Major est le {memberIdentifier}</h4>" +
                "<p><br />Vous recevrez un courriel de confirmation pour votre demande de récupération de Code Major dans les prochaines heures.</p>" +
                "<p><br />Si vous ne recevez cette confirmation dans les 24 prochaines heures, veuillez contacter Plan Major au 1-877-976-2567 ou à <a href='mailto:étudiant@planmajor.ca'>étudiant@planmajor.ca</a>. Assurez-vous de vérifier le contenu de vos courriels indésirables avant de communiquer avec nous.</p>" +
                "<p><br />Lors de chacune de vos réclamations et communications avec Plan Major, veuillez mentionner votre Code Major.</p>" +
                "<p><br />En plus de votre couverture, le Plan Major vous offre des rabais supplémentaires avec des professionnels de la santé/dentaire. Visitez la section <a target='_blank' href='https://planmajor.ca/fr/rabais-reseau/'>Rabais Réseau</a> pour plus d’informations.</p>",
        },
    },
    memberFiles: {
        title: "Générations de fichiers",
        dataTable: {
            name: "Participant",
            coverageDate: "Date de couverture",
            generationDate: "Date de génération",
            error: "Erreur",
            files: "Fichiers",
            majorCard: "Carte Major",
            status: "Statut",
            selectAll: "Sélectionner tout",
            regenerateButton: "Régénérer la sélection",
            statuses: {
                failure: "Échec",
                started: "Commencé"
            },
            toasts: {
                regenerateInitiated: "Nouvelle génération des fichiers initiée pour les participants sélectionnés. Merci de patienter quelques instants.",
                regenerateInitiatedMajorCard: "Nouvelle génération de la carte Major initiée pour le(s) participant(s) sélectionné(s). En cas de problème, la génération sera accessible via la page Génération de fichiers du client.",
                regenerateInitiatedMajorCardError: "Échec de la génération de la carte Major : les participants sélectionnés sont tous archivés, ils n'ont aucune couverture active, ou ils n'ont pas d'adresse courriel.",
                regenerateInitiatedMajorCardErrorSingular: "Échec de la génération de la carte Major : ce participant est archivé, n'a aucune couverture active, ou n'a pas d'adresse courriel.",
                partialRegenerateInitiatedMajorCardError: "Génération partielle de la carte Major lancée. Certains participants sélectionnés sont archivés, n'ont pas de couverture active, ou n'ont pas d'adresse courriel :{br}",
                regenerateError: "Une erreur s'est produite lors de l'initialisation de la nouvelle génération des fichiers. Veuillez réessayer.",
                regenerateMajorCardError: "Une erreur s'est produite lors de l'initialisation de la génération de fichier. Veuillez réessayer.",
                allMembersArchivedError: "Tous les participants sélectionnés sont archivés ou introuvables et ne peuvent pas avoir leurs fichiers regénérés.",
                allMembersNonEligibleError: "Tous les participants sélectionnés ont déjà eu une regénération de fichier en succès et ne peuvent pas avoir leurs fichiers générés à nouveau."
            },
            errors: {
                noCoverageFound: "Le participant n'a pas de couverture active",
                noHealthOrTravelGuarantee: "Le participant n'a pas de garantie voyage ou santé",
                technicalError: "Une erreur est survenue. Merci de contacter le support. Plus d'information : {error}",
                timeout: "Le fichier n'a pas pu être généré dans les délais."
            },
            noFileMessage: "Aucun fichier défini pour ce participant"
        }
    },
    messages: {
        title: "Messages",
        datatable: {
            actions: {
                add: "Ajouter un message",
                edit: "Modifier le message",
                view: "Visionner le message",
                showConfirm: {
                    title: "Attention !",
                    message:
                        "Si vous fermez maintenant vos données ne seront pas sauvegardées. Souhaitez-vous continuer ?",
                },
            },
            columns: {
                date: "Date",
                createdBy: "Créé par",
                message: "Message",
                read: "Lu",
                unread: "Non lu",
            },
        },
        form: {
            message: "Message",
        },
    },
    passwordForm: {
        passwordMessage: "Réinitialisation de mot de passe",
        passwordMessageBody:
            "<p>Un courriel de réinitialisation de mot de passe va vous être envoyé à l'adresse <a target='_blank'>{emailAddress}</a></p>" +
            "<p>Si l’adresse courriel est erronée, veuillez contacter votre gestionnaire de compte ou le support</p>" +
            "<p>Souhaitez-vous poursuivre ?</p>",
        changePassword: "Changer mot de passe",
    },
    downloadsModal: {
        title: "Téléchargements en cours",
        noDownloads: "Aucun téléchargement en cours.",
        success: "Téléchargé avec succès: {identifier}",
        error: "Erreur de téléchargement: {identifier} {message}",
    },
    publicPage: {
        header: {
            majorPlan: "Le Plan Major",
            studentSolution: "La solution étudiante",
            yourAssociation: "Votre association",
        },
        404: {
            title: "404",
            text: "La page que vous cherchez n'existe pas.",
        },
        footer: {
            copyrights:
                "&copy; <a target='_blank' href='http://www.groupemajor.ca/fr'>Groupe Major</a>. Tous droits réservés",
            contactEmail: "<span>Écrivez-nous</span><a href='mailto:etudiant@planmajor.ca'>etudiant@planmajor.ca</a>",
            contactPhone: "<span>Sans frais</span><a href='tel:+18779762567'>1.877.976.2567</a>",
        },
    },
    salesTaxes: {
        title: "Gestion des taxes",
        unit: "%",
        applicablePeriod: "Période applicable",
        types: {
            hst: "TPS / TVH",
            pst: "TVP / TVQ",
            insurance: "Assurances",
            surtax: "Surtaxe",
        },
        editTaxWarning: "Seules les valeurs fiscales actuelles sont susceptibles de changer.",
    },
    search: {
        datatables: {
            clients: {
                division: "Division",
            },
            members: {
                client: "Client",
                name: "Nom",
            },
        },
        noResults: "La recherche n'a donné aucun résultat.",
        placeHolder: "Numéro unique, nom, client, n° de téléphone numérique comme 5141234567, date de naissance comme 31/01/2001",
        title: "Résultats de recherche",
    },
    status: {
        active: "Actif",
        activeComplete: "Actif complet",
        activePartial: "Actif partiel",
        inactive: "Inactif",
        archived: "Archivé",
        unarchived: "Non archivé",
        incomplete: "Incomplet",
        canceled: "Annulé",
        generated: "Généré",
        generating: "En cours de génération",
        implementation: "Mise en vigueur",
        terminated: "Terminé",
        emailVerified: "Courriel vérifié",
        emailNotVerified: "Courriel non vérifié",
    },
    suppliersReports: {
        datatable: {
            actions: {
                download: "Télécharger",
            },
            columns: {
                month: "Mois",
                size: "Taille",
                actions: "Actions",
            },
        },
    },
    validation: {
        archiveForbidden: "Il n'est pas possible de modifier une donnée archivée",
        array: "Une erreur s'est produite",
        atLeastOne: "Vous devez sélectionner au moins un élément",
        emailRegex: "Le champ doit être un format d'adresse courriel valide sans espace et sans accent",
        fileNameContainsSubString: "Le nom du fichier doit contenir {ruleValue}",
        fileOfExtension: "Le fichier téléverser doit avoir une extension de type {ruleValue}",
        fileOfSignature: "Le fichier téléverser ne respecte pas la signature attendue",
        isRequired: "Le champ doit contenir une valeur",
        isRequiredFile: "Aucun fichier a été sélectionné",
        isRequiredTrim: "Le champ doit contenir une valeur",
        isRequiredTrimShort: "Valeurs requise",
        legalTextCheckBoxValidation: "La case doit être cochée pour soumettre le formulaire",
        cityRegex: "Ce champ ne doit contenir que des caractères alphabétiques",
        maxLength: "Le champ ne peut contenir plus de {ruleValue} caractères",
        minLength: "Le champ ne peut contenir moins de {ruleValue} caractères",
        minValue: "Le champ doit être d'une valeur minimale égale à {ruleValue}",
        mustMatch: "Le champ doit avoir la même valeur que le champ {ruleValue}",
        mutuallyExclusiveWith: "Ne peut être sélectionner en même temps que {other}",
        noSpaces: "Le champ ne peut pas contenir d'espace blanc",
        noSpacesBeginning: "Le champ ne peut pas commencer par un espace",
        noSpacesEnd: "Le champ ne peut pas se terminer par un espace",
        onlyNumerical: "Le champ peut contenir seulement des chiffres.",
        stringSameCharacters: "Le champ ne peut pas contenir une suite d'une même valeur",
        regex: "Le champ doit être du bon format",
        websiteRegex: "Veuillez entrer l'URL d'un site Web valide (par exemple, http://www.example.com)",
        float: "Le champ doit être un chiffre ou un chiffre décimal",
        higherThan: "La valeur entrée doit être plus haute que {ruleValue}",
        lowerThan: "La valeur entrée doit être plus basse que {ruleValue}",
        EqualOrGreaterThanStartDate: "Doit être supérieur ou égal à la date de début",
        cannotExceed100: "La valeur ne peut dépasser 100",
        valueBetween: "La valeur doit être entre {minimum} et {maximum}",
        memberValidation: {
            noMemberIdentifier:
                "Le numéro de client est nécessaire pour créer un participant avec une option d'identifiant automatique.",
            noClientNumber:
                "La création d'un participant est actuellement impossible car le numéro de client n'est pas renseigné dans le profil du client, sous la rubrique 'Informations générales'.",
        },
        clientFieldValidation: {
            attention: "Attention !",
            validationInProgress: "Validation en cours ...",
            tedDesjardinsValidationMemberConfig: "La configuration des numéros uniques des participants doit être automatique pour les clients ayant le choix de synchronisation TED Desjardins.",
            tedDesjardinsValidationMemberIdentifierType: "La longueur du numéro unique doit être personnalisée pour les clients ayant le choix de synchronisation TED Desjardins (doit avoir une longueur de 9).",
            tedDesjardinsValidationMemberIdentifierLength: "La longueur du numéro unique doit être 9 pour les clients ayant le choix de synchronisation TED Desjardins.",
            generalSuccessMessage: "Le client {client} a été créé avec succès.",
            clientChangeStatusSuccessTitle: "Le client est prêt à passer {status}",
            clientActivePassageMessage:
                "En passant ACTIF, les couvertures de participants, de classes et les prix de couverture commençant avant le {coverageDate} ont été automatiquement reconfigurées pour débuter au {coverageDate}. Attention, celles débutant après le {coverageDate} n'ont pas été modifiées.",
            clientChangeStatusValidationSuccess:
                "Les informations requises pour le passage {status} du client ont été renseignées.",
            creationAction: "création",
            modifyAction: "modification",
            unknownAPIError: "Une erreur est survenue.",
            clientTransitionError:
                "Une transition d'état pour ce client est déjà en cours, merci de réessayer dans quelques minutes.",
            clientChangeStatusValidationError:
                "Plusieurs informations sont manquantes pour effectuer le changement de statut.{br}Merci de renseigner les informations ci-dessous:{br} {br}",
            generalErrorMessage:
                "Attention, plusieurs informations sont manquantes pour la {actionType} du client.{br}Merci de renseigner les informations ci-dessous: {br} {br}",
            clientNumberMandatoryWarn: "Le numéro de client est obligatoire pour tous les clients actifs.",
            invoiceMEVError: "Impossible de générer la facture GABARIT, il manque les informations suivantes:{br}",
            clientNumberWarnForIdentifier:
                "Le numéro de client est obligatoire pour l'option du numéro unique automatique des participants.",
            emptyMemberIdentifierTypeWarn: "Le type de numéro unique pour les participants est obligatoire.",
            emptyInitialLengthWarn: "La longueur du numéro unique du participant est obligatoire.",
            invalidMemberIdentifierLength:
                "La longueur de l'identifiant automatique du participant doit être au moins 6.",
            missingClientNumberForAutomaticIdentifier:
                "Attention, le numéro de client est obligatoire pour la génération automatique du numéro de certificat des participants et doit être renseigné avant la création du premier participant.",
            clientActivationFieldError: "Impossible d'activer le client, il manque les informations suivantes:{br}",
            clientActivationError:
                "Le statut du client n'a pas pu être mis à jour en raison de problèmes techniques, veuillez contacter le support",
            activeSuccess: "Le client {client} a été passé au statut actif avec succès",
            coverageWarning:
                "Attention, en rendant ce client actif il sera inclus dans la prochaine période de facturation ({nextBP}).{br}Or, sa date de début de couverture est en {coverageMonth}.{br}Toutes les factures avant sa date de début de couverture seront générées à 0$.{br}Êtes-vous sûr(e) de poursuivre?",
            serverErrors: {
                emptyNameField: "Nom usuel",
                emptyFullNameField: "Nom complet",
                emptyDesignatorField: "Sigle",
                emptyAddressField: "Addresse",
                emptyCityField: "Ville",
                emptyProvinceCodeField: "Province",
                emptyPostalCodeField: "Code postal",
                emptyBusinessAccountTypeField: "Type de compte",
                emptySyncTypeField: "Choix de synchronisation API",
                emptyBlocIdField: "Bloc",
                emptyBillingPeriodTypeField: "Périodes de facturation",
                emptyClientStatusTypeField: "Statut",
                emptyStartDateField: "Période de couverture - Date de début",
                emptyEndDateField: "Période de couverture - Date de fin",
                clientNumberMandatory: "Numéro de client",
                emptyAccountManagerIdField: "Un utilisateur gestionnaire de compte associé à ce client",
                emptyPolicyNumber: "Numéro de police manquant pour la ou les garantie(s): {}",
                badlyConfiguredPolicyNumber: "Numéro de police invalide pour la ou les garantie(s): {}",
                emptyClassClientCoverage: "Couvertures des classes du client",
                emptyAdminContactFirstNameField: "Prénom du contact administratif",
                emptyAdminContactLastNameField: "Nom du contact administratif",
                emptyAdminContactJobPositionField: "Titre du contact administratif",
                emptyAdminContactPhoneNumberField: "Numéro de téléphone du contact administratif",
                emptyAdminContactEmailAddressField: "Courriel du contact administratif",
                emptyAdminContactLanguageCodeField: "Langue de contact du contact administratif",
                emptyClientNumberField: "Numéro de client (Telus ou Desjardins)",
                emptyAcombaNumberField: "Numéro de client (ACOMBA)",
                emptyAcombaProjectNumberField: "Numéro de projet",
                emptyPaymentTypeField: "Mode de paiement",
                emptyIsAutomaticMemberIdentifierField: "Configuration du numéro unique des participants",
                emptyMemberIdentifierTypeField: "La longueur des numéros uniques des participants",
                emptyMemberIdentifierInitialLengthField: "Longueur du numéro unique",
                emptyMemberIdentifierInitialLengthCustomField: "Longueur du numéro unique entre 6 et 15 caractères",
                emptyAccountManagerField: "Un utilisateur gestionnaire de compte associé à ce client",
                hasGenericAccountManager: "Le client a un gestionnaire de compte générique",
                emptyBillingPeriod: "Période de facturation",
                emptyInvoice: "Facture gabarit avec un montant supérieur à zéro",
                emptyClass: "Classe",
                emptyClientCoverage: "Couverture de client",
                emptyDivision: "Division",
                emptyExternalDivisionNumber: "Le numéro de division Telus ou Desjardins pour la ou les division(s): {}",
                emptyExternalClassNumber: "Le numéro de classe Telus ou Desjardins pour la ou les classe(s): {}",
                emptyPlanAdministrator: "Un utilisateur administrateur de régime associé à ce client",
                invalidTemplateInvoice: "Une facture gabarit valide ayant au moins un participant actif et non archivé",
                emptyServiceRepresentativeIdField: "Un utilisateur représentant de service associé à ce client",
                emptyCreditsInvoiceCountField: "Nombre de factures d'ajustement",
                emptyCreditsInvoiceFrequencyField: "Fréquence des factures d'ajustement",
                billingPeriodDateError:
                    "Une période de facturation est en cours, impossible de planifier le dernier jour d'activité du client",
                misconfiguredManualBillingPeriods: "Paramètres de facturation manquants pour les périodes: {}",
            }
        },
        customMessages: {
            alphanumeric: "Seul les caractères alphanumériques sont permis",
            numeric: "Seul les caractères numériques sont permis",
            clientError: "Une erreur est survenue. Merci de réessayer dans quelques instants. Si le problème persiste, veuillez contacter le support.",
            serverErrors: {
                duplicateUsername: "L'identifiant entré existe déjà dans la base de données",
                userCreationError:
                    "Une erreur est survenue lors de la création de l'utilisateur. Veuillez contacter le support.",
                buAssociatedError:
                    "Une erreur est survenue lors de la création des liens de l'utilisateur avec son unité d'affaire. Veuillez contacter le support.",
                unauthorizedClientError:
                    "Une erreur est survenue lors de la création des liens de l'utilisateur avec son client. Veuillez choisir un client de la même unité d'affaire ou contacter le support.",
                passwordLinkError:
                    "L'utilisateur a été créé, mais il y a eu un problème lors de l'envoi du lien pour définir le mot de passe. Veuillez contacter le support.",
                clientNumberError: "Le numéro de client ne peut pas être modifié si le client possède déjà un membre",
                existingClientConfigurationError: "Le numéro de client utilisé existe déjà pour un autre client mais sa configuration n'est pas compatible avec le mode de synchronisation DESJARDINS.",
                duplicateBlocName: "Le nom de bloc entré existe déjà dans la base de données",
                duplicateGroupName: "Un groupe avec ce nom existe déjà. Veuillez choisir un autre nom de groupe",
                duplicateClassName: "Le nom de classe entré existe déjà dans la base de données",
                duplicateClientName: "Le nom de client entré existe déjà dans la base de données",
                duplicateDesignator: "L'acronyme du client entré existe déjà dans la base de données",
                duplicateDivisionName: "Le nom de division entré existe déjà dans la base de données",
                duplicateMemberIdentifier: "Le numéro unique entré existe déjà dans la base de données",
                dateRequired: "La période de couverture est obligatoire pour le modèle d'entreprises",
                accountTypeRequired: "Le type de compte est requis",
                businessAccountTypeUneditable: "Vous ne pouvez pas modifier l'unité d'affaire",
                genericError: "Une erreur inconnue est survenue. Veuillez réessayer plus tard",
                driving_cannot_depend_on: "Il n'est pas possible pour une garantie pilote de garantie obligatoire de personne à charge d'être définie comme garantie dépendante d'une autre",
                depends_on_cannot_be_driving: "Il n'est pas possible pour une garantie dépendante d'une autre d'être définie comme garantie pilote de garantie obligatoire de personne à charge",
                wrongAuthorizationCode: "Le code d'autorisation est erroné",
                wrongPassword: "Le mot de passe est invalide",
                clientNumberRequired: "Le numéro de client est obligatoire pour les clients du groupe major",
                clientNumberMandatory: "Le numéro de client est obligatoire pour les clients du groupe major",
                clientNumberUneditable: "Le numéro de client ne peut pas être modifié pour les clients du groupe major",
                memberIdentifierConfigurationUneditable:
                    "Le type d'identifiant pour les membres ne peut pas être modifié",
                internalContactsConfigurationUneditable:
                    "Les contacts internes ne peuvent pas être modifiés pour les clients inactifs ou terminés.",
                billingPeriodCreationError: "La création de la nouvelle période de facturation n'a pas pu aboutir",
                billingPeriodDelayCriteriaError: "La période de facturation n'est pas éligible au décalage",
                noSymbolsInClientNumber:
                    "Le numéro de client ne peut pas contenir des symboles.",
                noAlphabetInClientNumber:
                    "Le numéro de client ne peut pas contenir de lettres pour les entreprises clientes du groupe major",
                manualMemberIdentifierType: "Dû à la méthode manuelle utilisée pour générer le numéro de certificat du participant, ce numéro de client (TELUS ou Desjardins) déjà existant ne peut être réutilisé.",
                invalidClientBlocError:
                    "Le changement de bloc non facturable n'est pas autorisé. Si une telle manipulation est souhaitée, merci de créer un nouveau client.",
                noHealthOrTravelGuaranteeFoundForMember: "Le membre n'a pas d'assurance voyage ou maladie",
                generic: "Une erreur est survenue.",
                noTravelHealthFoundForClient: "Le client n'a pas d'assurance voyage ou maladie",
                NoCoverageFound: "Le membre {identifier} n'a aucune couverture",
                retroactiveFetchError:
                    "Une erreur s'est produite lors de la récupération de la date limite de modification rétroactive. Veuillez contacter l'assistance.",
                mfaPreferenceUpdateError:
                    "Une erreur s'est produite lors de la mise à jour de la préférence de réception du code MFA. Veuillez contacter l'assistance.",
                invalidNewPasswordError: "Mot de passe invalide.",
                forbiddenSimultaneousDependentAndMandatoryGuarantee: "Une garantie ne peut être à la fois dépendante et obligatoire."
            },
            coverageStartDate:
                "La couverture ne peut pas débuter avant ou la même journée que la couverture précédente",
            emailAddressRegex: "Le courriel devrait être de format: exemple@courriel.com",
            emailAddressMatch: "Les adresses courriels ne correspondent pas",
            postalCodeRegex: "Le code postal devrait être de format: A1A1A1",
            startDate: "La date de début doit être avant la date de fin",
            endDate: "La date de fin doit être après la date de début",
            birthdate: "La date de début du handicap ne doit pas être avant la date de naissance",
            startDateAfterClientCreation:
                "La période de couverture du client ne peut pas commencer plus de 6 mois avant aujourd'hui",
            minimumDate: "La date entrée doit être plus tard que le {ruleValue, date, long}",
            banking: {
                transitNumber: "Le numéro de transit doit contenir 5 chiffres",
                institutionNumber: "Le numéro d'institution doit contenir 3 chiffres",
                accountNumber: "Le numéro de compte doit contenir de 5 à 12 chiffres",
                accountNumberSevenDigit: "Votre numéro de compte doit contenir 7 chiffres",
                bankCheckDigit: "Le chiffre vérificateur doit contenir 1 chiffre",
                bankAccountOwnerName: "Le nom du titulaire du compte bancaire doit contenir un nom",
            },
            noActiveGuarantees: "Vous devez avoir au moins une garantie active",
            noBillingPeriods: "Vous devez avoir au moins une période de facturation de configurée",
            recaptchaFailed: "La vérification reCaptcha n'a pas fonctionnée.",
            recaptcha: "Vous devez prouver que vous n'êtes pas un robot",
            acceptCondition: "Vous devez accepter cette condition",
            passwordRegex: "Le mot de passe ne respecte pas les conditions",
            passwordRules:
                "<div>Le mot de passe doit :" +
                "<ul>" +
                "<li>contenir un minimum de 12 caractères;</li>" +
                "<li>avoir au moins une lettre minuscule;</li>" +
                "<li>avoir au moins une lettre majuscule;</li>" +
                "<li>avoir au moins un symbole;</li>" +
                "<li>avoir au moins un chiffre.</li>" +
                "</ul>" +
                "</div>",
            passwordWebsite:
                "https://www.cyber.gc.ca/fr/orientation/guide-sur-lauthentification-des-utilisateurs-dans-les-systemes-de-technologie-de#a21",
            passwordWebsiteString: "Site gouvernemental de recommandations de gestion de mot de passe",
        },
    },
    invoicingConfig: {
        successToast: "Les données ont été sauvegardées avec succès",
        form: {
            title: "Paramétrage des factures d'ajustement",
            submit: "Soumettre",
            creditsInvoiceFrequency: "Fréquence des factures d'ajustement (en mois)",
            creditsInvoiceCount: "Nombre de factures d'ajustement",
            description:
                "Cette page permet de définir les valeurs par défaut du paramétrage des factures d'ajustement rétroactif. Pour chaque période de facturation, ces valeurs seront renseignées et pourront être modifiées.\
            Le délai légal pour prendre en compte les ajustements sur une période de facturation est de {year} ans. Vous devez renseigner la fréquence mensuelle de génération des factures d'ajustement sur ces {year} années.",
            calculatedInformation:
                "Une facture d'ajustement sera générée tous les {frequency} mois.<br />Pour chaque période de facturation {invoiceCount} factures d'ajustement seront générées sur {year} ans.",
        },
    },
    clientContacts: {
        successStrategicToast: "Les contacts stratégiques ont été sauvegardés avec succès",
        successOperationalToast: "Les contacts opérationnels ont été sauvegardés avec succès",
        archiveToast: "Le contact {archivedName} a été supprimé avec succès",
        archiveConfirmationMessage: "Êtes-vous certain de vouloir supprimer le contact {archivedName} ?",
        form: {
            operationalContact: {
                title: "Contacts opérationnels",
                save: "Sauvegarder",
                internalContacts: "Contacts internes",
                emailAddress: "Adresse courriel",
                firstName: "Prénom",
                lastName: "Nom de famille",
                contactTitle: "Titre",
                phoneNumber: "Numéro de téléphone",
                phoneExtension: "Poste",
                mainTitle: "Contact principal",
                adminTitle: "Contact administratif",
                language: "Langue de contact",
                accountManager: "Gestionnaire de compte",
                serviceRepresentative: "Représentant(e) de service",
                enterPhoneNumber: "Veuillez entrer un numéro de téléphone valide",
                extensionNumber: "Numéro de poste",
                phoneNumberFormatError: "Le numéro de téléphone doit respecter le format suivant: (XXX) XXX-XXXX."
            },
            strategicContact: {
                title: "Contacts stratégiques",
                contact: "Contact {contactIndex}",
                save: "Sauvegarder",
                emailAddress: "Adresse courriel",
                firstName: "Prénom",
                lastName: "Nom de famille",
                contactTitle: "Titre",
                phoneNumber: "Numéro de téléphone",
                language: "Langue de contact",
                role: "Rôle",
                linkedin: "LinkedIn",
                linkedInWebsiteError: "Le format de l'URL LinkedIn est invalide.",
                linkedInWebsiteRegex: "Adresse LinkedIn invalide. Format accepté : https://linkedin.com/in/nom-du-profile{br}",
                linkedInWebsiteRegexList: "<ul>" +
                    "<li>3 caractères minimum pour le <u>nom-du-profile</u></li>" +
                    "<li>Caractères spéciaux autorisés pour le <u>nom-du-profile</u> : ~%-</li>" +
                    "</ul>",
                comment: "Commentaire",
                primaryStrategicContact: "Contact stratégique principal",
                notePlaceholder: "Entrez votre commentaire ici",
                noteLimitError: "La saisie est limitée à 500 caractères.",
                roles: {
                    executive: "Direction",
                    finance: "Finance",
                    hr: "Ressources humaines",
                    other: "Autre",
                    select: "Sélectionner..."
                }
                ,
                mainStrategicMessage: "Le client ne peut avoir qu’un seul contact stratégique principal",
            },
        },
    },
    personalData: {
        form: {
            title: "Révision des informations personnelles",
            memberIdentifier: "Numéro de certificat",
            email: "Courriel",
            confirmEmail: "Confirmer votre courriel",
            verifyInformation: "Veuillez vérifier les informations suivantes:",
            informationMessage:
                "Si les informations sont erronées vous pouvez les mettre à jour, votre dossier sera automatiquement mis à jour",
            personalInfoTitle: "Informations personnelles",
            postalInfoTitle: "Adresse postale",
            firstName: "Prénom",
            lastName: "Nom de famille",
            phoneNumber: "Numéro de téléphone",
            birthDate: "Date de naissance",
            gender: "Sexe",
            language: "Langue",
            address: "Adresse",
            city: "Ville",
            country: "Pays",
            province: "Province",
            postalCode: "Code postal",
            noFormAvailable: "Aucun formulaire est disponible pour ce client.",
            conditions: "Conditions",
            definedConditions:
                "Pour remplir ce formulaire, vous devez être une personne étudiante membre de l'association étudiante dont l'acronyme / nom se retrouve dans le haut du formulaire. <br /><br />" +
                "L'information donnée doit être la mienne et non celle d'une autre personne. <br /><br />" +
                "Si vous êtes aux études collégiales, assurez-vous d'être sur le bon formulaire en fonction de votre type d'études (formation régulière – FR / formation continue – FC).",
            readInfoWarn:
                "Vous devez utiliser cette page pour controler vos données du régime d'assurance collective. Veuillez lire les renseignements avant de remplir le formulaire.",
            procedure: "Procédures",
            definedProcedure:
                "Votre numéro de certificat doit correspondre à celui utilisé par votre association étudiante.<br />" +
                "Pour plus d'informations sur votre numéro de certificat, veuillez-vous référer à : <a href='https://planmajor.ca/fr/mon-numero-de-certificat/'>https://planmajor.ca/fr/mon-numero-de-certificat/ </a> <br /><br />" +
                "Remplissez ce formulaire en vous assurant d'entrer la bonne information. Si l'information entrée est erronée, cela impactera de manière importante le service que vous recevrez de Plan Major. <br /><br />" +
                "Assurez-vous de bien cliquer sur le bouton « soumettre » et de confirmer la réception du courriel de confirmation de soumission du formulaire.<br /><br />" +
                "Suite à la soumission du formulaire, il peut y avoir un délai allant jusqu'à 7 jours ouvrables pour que votre dossier d'assurance soit actif. Pendant cette période, il est normal que vous ne puissiez pas vous créer un compte sur l'application mobile ou le portail web ni soumettre des réclamations directement au cabinet dentaire ou en pharmacie. <br /><br />" +
                "Contactez Plan Major si vous ne recevez pas votre courriel de confirmation dans les 24 heures suivant la soumission du formulaire (vérifiez votre boîte pourriel ou indésirable).",
            formToFillTitle: "Formulaire de demande à remplir",
            submitBtn: "Soumettre",
            infoAboutSubmission:
                "Afin de renseigner le formulaire de contrôle des informations personnelles, vous devez passer par la procédure d'accès sécurisé. Un code vérificateur vous sera envoyé à votre adresse courriel afin de vérifier votre identité.",
            verificationCodePopUp:
                "Vous allez recevoir un courriel avec un code vérificateur dans les prochaines minutes. Ce code a une durée de validité de 30 minutes. Suite à ce laps de temps un seconde code vous sera envoyé. Veuillez renseigner ce code pour poursuivre.",
            verificationCodeModalTitle: "Information",
            verificationCodeLabel: "Code vérificateur",
            attention: "Attention !",
            unknownMemberErr:
                "<span>Votre profil n'a pas été trouvé, veuillez vérifier vos informations. Si vos informations sont correctes veuillez contacter le service client de Plan Major à <a href='mailto:etudiant@planmajor.ca'>etudiant@planmajor.ca</a>.</span>",
            infoError: "Une erreur est survenue, veuillez vérifier vos informations.",
            retryCheckCode: "Je n'ai pas reçu le code -> Envoyer",
            pleaseVerify: "Veuillez vérifier les informations suivantes :",
            pleaseVerifyInfo:
                "Si les informations sont erronées vous pouvez les mettre à jour, votre dossier sera automatiquement mis à jour",
            formEndMessage:
                "Vous recevrez dans les prochaines heures un courriel de confirmation de mise à jour de vos informations personnelles. Si vous n’avez pas reçu cette confirmation dans les prochaines 24 heures, veuillez contacter le Plan Major au 1-877-976-2567 ou etudiant@planmajor.ca",
            formEndTitle: "Formulaire complété",
            checkCodeValidity:
                "Le code saisi a une durée de validité de {time} minutes. Passé ce délai, il vous faudra en demander un nouveau.",
            checkCodeTimeError: "Le code du membre a été créé il y a moins de 3 minutes. Veuillez réessayer plus tard.",
            legalText:
                "Je confirme que les informations fournies sont véridiques, et qu'en cas d'erreur ou d'omission de ma part, cela pourrait compromettre la qualité du service offert, voire même rendre impossible la prestation de service de Plan Major.",
            legalTextIdentity:
                "Je confirme que je suis bien la personne pour laquelle je fournis les informations et qu'en cas contraire, il pourrait s'agir d'usurpation d'identité. Plan Major, l'association étudiante ou la personne visée pourrait ainsi entreprendre des recours contre moi.",
            legalTextDataUsage:
                "Je confirme que je comprends et je suis d'accord que l'information fournie dans ce formulaire en ligne sera utilisée à l'interne dans l'équipe Plan Major pour le bon fonctionnement des services offerts et que mes informations pourront être partagées par écrit avec les assureurs ou autres fournisseurs de services qui sont inclus dans l'offre de service retenu par mon association étudiante. Il est aussi possible que mon association étudiante ou mon institution aient accès à cette information. Si je désire retirer ce consentement, je devrai communiquer avec Plan Major par écrit.",
            legalTextDelay:
                "Je comprends qu'il peut y avoir un délai allant jusqu'à 7 jours ouvrables entre le moment où je soumets le présent formulaire et celui où mon dossier d'assurance sera actif. Pendant cette période, il est normal que je ne sois pas en mesure de me créer un compte sur l'application mobile ou le portail web et de soumettre des réclamations directement au cabinet dentaire ou en pharmacie.",
        },
    },
    withdrawal: {
        body: {
            title: "Demande de retrait du régime",
            introduction:
                "<p>Vous devez utiliser cette page pour remplir votre demande de retrait du régime d'assurance collective. Veuillez lire les renseignements avant de remplir le formulaire.</p>",
            conditions:
                "<h3>Conditions</h3>" +
                "<p>Votre demande de retrait doit être faite dans les délais prescrits. Vous n'aurez pas d'autre occasion d'exercer votre option de retrait automatique.</p>" +
                "<p>Vous devez avoir la mention d'assurance collective sur votre facture institutionnelle étudiante.</p>",
            conditionsPerm:
                "<p>Le retrait permanent est valable pour toute la durée de vos études (tous cycles considérés), que vos études soient continues ou interrompues. Le régime d'assurance collective offre certaines modalités de réintégration non automatiques.</p>",
            procedure:
                "<h3>Procédure</h3>" +
                "<p>Pour vous retirer du régime d'assurance, veuillez suivre la procédure suivante :</p>" +
                "<ul>" +
                "<li>Replissez le formulaire Web ci-dessous et envoyez-le</li>" +
                "<li>Consultez votre boîte de courriel dans les heures qui suivent l'envoi du formulaire. Vous recevrez un courriel attestant que votre demande a été enregistrée. <strong class='emphasis'>Conservez ce courriel</strong>.</li>" +
                "</ul>",
            withdrawalClosed: "La période de modifications et désistement est présentement fermée.",
        },
        form: {
            title: "Formulaire de demande à remplir",
            memberIdentifier: "Numéro de certificat",
            institutionEmail: "Courriel institutionnel",
            memberEmail: "Courriel",
            confirmEmail: "Confirmer votre courriel",
            permanentWithdrawal: "Je désire me retirer de façon permanente du régime d'assurance collective",
            annualWithdrawal: "Je désire me retirer de façon annuelle du régime d'assurance collective",
            sessionWithdrawal: "Je désire me retirer du régime d'assurance collective pour cette session",
            conditions: {
                byWithdrawing: "En me retirant du régime :",
                haveRead:
                    "je confirme avoir lu la documentation fournie sur ce site concernant le régime d'assurance collective ;",
                acceptance:
                    "j'accepte la procédure de retrait et je comprends que <strong class='emphasis'>le courriel de confirmation constitue la seule preuve de désistement acceptable</strong> ;",
                legalUnbinding:
                    "je libère Plan Major, mon association étudiante, les compagnies d'assurance (si applicable), ainsi que toutes autres parties concernées de toutes responsabilités à l'égard de préjudices ou de réclamations ;",
                understanding:
                    "je comprends qu'en me retirant de façon permanente du régime, je ne pourrai pas y adhérer de nouveau à moins de répondre aux critères et modalités établis par mon association étudiante, qui peuvent changer sans préavis.",
                withdrawFromTheRegime:
                    "En me retirant du régime, je consens au partage de mes informations personnelles (prénom, nom, date de naissance, numéro identifiant et adresse) avec mon institution d'enseignement et mon association étudiante afin de leur confirmer mon désistement du service, si nécessaire.",
                correctBankInfo:
                    "Je certifie que les coordonnées bancaires fournies sont exactes, je libère Plan Major de toutes responsabilités dans le cas où celles-ci sont erronées et je comprends que Plan Major pourrait appliquer des frais administratifs pour la réémission d'un paiement.",
                bankAccountOwner:
                    "Je confirme que je suis titulaire du compte bancaire et que je suis la personne membre se désistant du régime.",
            },
            submit: "Soumettre",
            verificationCode: "Code de vérification",
            refundWarning:
                "*Si vous choisissez un remboursement des frais d'assurance par chèque, ou si votre information bancaire pour le dépôt direct est inexacte, des frais  de 6.00$ vous seront chargés. Ils seront déduits du montant devant vous être remboursé.",
            refundCheck: "Par chèque",
            refundDeposit: "Par dépôt direct",
            checkSpecimenTooltip:
                "Voici un exemple de spécimen de chèque, incluant les informations que vous devez inscrire dans les champs requis. Information pour les membres Desjardins : votre numéro de compte est composé de 7 chiffres, le chiffre vérificateur correspond au dernier chiffre de votre numéro de compte.",
            refundFields: "Information du compte bancaire",
            refundAddress:
                "<p>" +
                "<strong>Le chèque sera envoyé à l'adresse suivante :</strong>" +
                "<br />{address}" +
                "<br />{city} {postalCode}" +
                "<br />{province} {country}" +
                "<br /><br /><em>Si l'adresse n'est pas la bonne, veuillez contacter le Plan Major.</em>" +
                "</p>",
            noLocalAddress: "<p><em>Vous n'avez pas d'adresse au dossier, veuillez contacter le Plan Major.</em></p>",
            transitNumber: "Numéro de transit",
            institutionNumber: "Numéro d'institution",
            accountNumber: "Numéro de compte",
            checkDigit: "Chiffre vérificateur",
            bankAccountOwnerName: "Titulaire du compte",
            withdrawalInformationTitle: "Type de désistement",
            withdrawalInformationTypes: "Choix du type de désistement:",
            withdrawalInformationPermanent: "Le désistement permanent vous désistera de façon permanente du régime.",
            withdrawalInformationAnnual:
                "Le désistement annuel vous désistera du régime pour l’ensemble de l’année académique actuelle.",
            withdrawalInformationSession:
                "Le désistement par session vous désistera pour la session en cours [{billingPeriod}] . Si vous êtes toujours aux études lors de la prochaine session, vous devrez vous désister de nouveau si vous ne désirez pas conserver la couverture à ce moment.",
        },
        messages: {
            errors: {
                blockedFromWithdrawal:
                    "Votre désistement est actuellement indisponible. Veuillez contacter le Plan Major pour obtenir plus d'information.",
                unpaidCoverage:
                    "Votre désistement est actuellement indisponible. Veuillez contacter le Plan Major pour obtenir plus d'information.",
                alreadyWithdrawn:
                    "Vous vous êtes déjà désisté de votre régime.",
                relatedCoverageStillActive:
                    "Vous ne pouvez vous désister puisque votre période de désistement était à la session précédente.",
                invalidMemberIdentifier:
                    "Le numéro d'identification que vous avez entré est invalide. Assurez-vous d'utiliser votre numéro institutionnel.",
                inactiveCoverage: "Vous n'êtes couvert par aucune garantie.",
                noCoverageFound: "Vous n'êtes couvert par aucune garantie.",
                noGuaranteeFound: "Vous n'êtes couvert par aucune garantie.",
                submitFailed:
                    "Une erreur est survenue lors de l'opération. Veuillez réessayer plus tard. Si le problème persiste, contactez un responsable de votre association.",
                "Server Error":
                    "Une erreur est survenue lors de l'opération. Veuillez réessayer plus tard. Si le problème persiste, contactez un responsable de votre association.",
                wrongVerificationCode: "Votre numéro de vérification n'est pas valide.",
                recaptchaFailed: "La vérification reCaptcha n'a pas fonctionnée.",
                bankAccountOwnerName: "Vous n'avez pas rempli le champ propriétaire du compte.",
            },
            informationModalTitle: "Information supplémentaire",
            success: "Votre demande de désistement a été complétée avec succès!",
            successModalTitle: "Désistement complété",
            successModalBody:
                "<p>Vous recevrez dans les prochaines heures un courriel de confirmation pour votre désistement.</p>" +
                "<p><br />Veuillez conserver ce courriel jusqu’à la fin de vos études. <strong>Ce courriel est la preuve que vous avez complété le processus de désistement et que vous êtes bien désisté</strong>.</p>" +
                "<p><br />Si vous n’avez pas reçu cette confirmation dans les prochaines 24 heures, veuillez contacter le Plan Major au 1-877-976-2567 ou à etudiant@planmajor.ca.</p>" +
                "<p><br />Avant de contacter le Plan Major, assurez-vous de vérifier vos courriels indésirables.</p>",
            validation: {
                confirmInstitutionalEmail: "Vous devez entrer votre courriel institutionnel",
                refundMethod: "Vous devez choisir une méthode de remboursement",
                verificationCode: "Vous devez entrer votre code de vérification",
                withdrawalMethod: "Vous devez sélectionner une méthode de désistement",
                withdrawalSelection: "Vous devez sélectionner au moins une couverture",
                acceptCondition: "Vous devez accepter cette condition",
            },
        },
    },
    withdrawalConfiguration: {
        title: "Configuration du désistement (si applicable)",
        supportedWithdrawals: "Désistements supportés",
        datatable: {
            actions: {
                add: "Ajouter un groupe de garanties",
                edit: "Modifier le groupe de garanties",
                includeArchivedCoverageGroups: "Inclure les groupes de garanties archivés",
            },
            columns: {
                name: "Nom du groupe",
                guarantees: "Garanties",
            },
        },
        email: {
            view: "Visualiser courriel",
        },
        form: {
            createWithdrawalForm:
                "Créer un <strong>formulaire de désistement</strong> pour chaque nouvelle période de désistement (désistement supporté par Groupe Major)",
            includeCodeAuthentication: "Inclure une authentification par <strong>code vérificateur</strong>",
            refuteWithdrawalForUnpaidCoverages:
                "Bloquer le désistement pour les étudiants n'ayant pas payé leur frais de scolarité",
            requireBankingInformation:
                "Support du remboursement (le participant sera appelé à choisir son mode de remboursement)",
            mustUseInstitutionEmailForWithdrawal: "Forcer l'utilisation du courriel institutionnel",
            hasWithdrawalFormMessage: "Afficher un message configurable au dessus du formulaire",
            hasWithdrawalPopupMessage:
                "Afficher un popup d'information suite à la vérification du numéro d'identification",
            withdrawalPopupTitle: "Titre du popup d'information",
            withdrawalPopupMessage: "Contenu du popup d'information",
            hasWithdrawalRedirectButton: "Configurer un bouton de redirection",
            redirectButtonMessage: "Message d'introduction du bouton",
            redirectButtonLabel: "Texte du bouton",
            redirectButtonURL: "URL du bouton",
            withdrawalFormMessage: "Message",
            allowPermanentDeactivation: "Désistement permanent",
            allowYearlyDeactivation: "Désistement annuel",
            allowSessionallyDeactivation: "Désistement par session",
            permanentDeactivationEmailTemplate: "Courriel de désistement permanent",
            yearlyDeactivationEmailTemplate: "Courriel de désistement annuel",
            sessionallyDeactivationEmailTemplate: "Courriel de désistement par session",
            coverageGroupDeactivationEmailTemplate: "Courriel de désistement d'un groupe de couverture",
            name: "Nom du groupe",
            guarantees: "Garanties",
            emailMessage: "Courriel de désistement du groupe",
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/intl/fr-CA.js